import { IAPIResponse, StatusCode } from "api/protocols";
import classNames from "classnames";
import { Badge } from "components/badge/Badge";
import { useAppDispatch, useAppSelector } from "hooks/redux";
import React, { ChangeEvent, useCallback, useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";
import { loadActiveTableNew, loadTableCart, setActiveTable } from "redux/actions/cart";
import { dequeue, enqueue, showError, showSuccess } from "redux/actions/ui";
import { ICart, ICartLineItem, IDiscountLines } from "redux/reducers/models/cart";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import "./tableServiceCart.scss";
import "../../tableService.scss";
import CartTotalsNew from "pages/secure/facility/register/registerNew/cartTotalsNew/CartTotalsNew";
import { IOrder, IInvoice } from "redux/reducers/models/order";
import { ButtonNew as Button } from "components/buttonNew";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck, faCircleDollar, faGripDots } from "@fortawesome/pro-solid-svg-icons";
import { faPaperPlane, faReceipt } from "@fortawesome/pro-light-svg-icons";
import {
  faArrowsRotate,
  faArrowRotateLeft,
  faBan,
  faChair,
  faFileLines,
  faFire,
  faNotes,
  faRightLeft,
  faTurnDownRight,
  faXmark,
  faArrowRight,
  faStar,
  faTicket,
  faTrashCanXmark,
  faNote,
  faPrint,
  faPercent,
  faChevronLeft,
  faChevronRight,
  faPlus,
  faListUl,
} from "@fortawesome/pro-regular-svg-icons";
import { GetOrder, GetPrintBulkReceipts, GetReceipt, PutOrder, PutOrderComplete, PutVoidOrder } from "api/rpc/2024-04/facilityAdmin/order/order";
import { useRegisterContext } from "pages/secure/facility/register/registerNew/RegisterContext";
import { ITableServiceState } from "../NewTableService";
import TableServiceCartLineItems from "./TableServiceCartLineItems";
import EditLineItemModal, { TUpdatedLineItem } from "../../LineItemModals/editLineItemModal/EditLineItemModal";
import { cloneDeep, isEqual } from "lodash";
import { DeleteLineItemToCart, PutLineItemToCart, PostLineItemToCart } from "api/rpc/2024-04/facilityAdmin/order/cart/lineItem";
import {
  canRemoveCartLineItem,
  canSetCartLineItemQuantity,
} from "helpers/cartLineItemPermissions";
import { DeleteDiscountLine, PostDiscountLine } from "api/rpc/2024-04/facilityAdmin/order/cart/discountLine";
import DiscountLineItemModal from "components/discountLineItemModal/DiscountLineItemModal";
import { IDiscount } from "api/rpc/2022-09/facilityAdmin/product/discount";
import Popup from "components/popup/Popup";
import Sheet from "components/sheet/Sheet";
import FormLayout from "components/form/FormLayout";
import { GetTicketStub, GetTicketValidate, PutTicketStubRedeemMultiple } from "api/rpc/2024-04/facilityAdmin/ticket/stub";
import Tabs from "components/tabs/Tabs";
import DataTable from "components/dataTable/DataTable";
import Input from "components/form/input/Input";
import PaymentMethods from "elements/register/cartMenu/PaymentMethods";
import Spin from "components/spin/spin";
import CartTransactions from "elements/register/cartMenu/CartTransactions";
import GiftCardRedeem, { IGiftCardRedeemState } from "components/giftCardRedeem/GiftCardRedeem";
import GiftCardSell from "components/giftcardSell/GiftCardSell";
import { GetGiftCardValidate } from "api/rpc/2024-04/facilityAdmin/payment/giftCard";
import AccountsModal from "components/accountsModal/AccountsModal";
import { IPrizeAccount } from "pages/secure/facility/settings/prizeAccounts/PrizeAccount";
import useModal from "hooks/modals/useModal";
import CreditBookModal from "components/creditBookModal/CreditBookModal";
import { GetRoomOccupants, IOccupant } from "api/rpc/room";
import { errorMessage, getDisplayCashChangeDue, isEmpty, printDesktopKitchenChit, printDesktopReceipt, displayCurrency } from "helpers/Helpers";
import { getOrderNetCollected, orderHasCollectedPayments } from "helpers/orderFinancial";
import { refundOrderPayments } from "helpers/refundOrderPayments";
import { serializeGiftCardsForSale } from "helpers/giftCardExpiry";
import Checkbox from "components/form/checkbox/Checkbox";
import axios, { CancelToken } from "axios";
import { PostTransaction } from "api/rpc/2022-09/facilityAdmin/order/transaction";
import {
  clearReaderDisplay,
  sheetInfo,
  processPayment as stripeProcessPayment,
  setReaderDisplay,
  convertOrderIntoDisplayInfo,
} from "helpers/StripeTerminalWrapper";
import { useStripeTerminalPayment } from "hooks/useStripeTerminalPayment/useStripeTerminalPayment";
import { useElements, CardNumberElement, CardExpiryElement, CardCvcElement } from "@stripe/react-stripe-js";
import {
  StripeCardCvcElementChangeEvent,
  StripeCardExpiryElementChangeEvent,
  StripeCardNumberElementChangeEvent,
} from "@stripe/stripe-js";
import CheckoutForm, { cancelManualCreditPaymentIntent } from "components/checkoutForm/CheckoutForm";
import { IStripePaymentState } from "pages/secure/facility/teesheet/TeeSheet";

import OrderCompletePopup from "components/orderCompletePopup/OrderCompletePopup";
import useFutureBookingPricingModal from "pages/secure/facility/customer/futureBookingPricingModal/useFutureBookingPricingModal";
import { promptFutureBookingPricingAfterMembershipOrder } from "pages/secure/facility/customer/futureBookingPricingModal/futureBookingPricingUtils";
import ActionModal, { IAction } from "components/actionModal/ActionModal";
import TableServiceSendLineItemsModal from "../../LineItemModals/TableServiceSendLineItemsModal";
import { PostKitchenChit } from "api/rpc/2024-04/facilityAdmin/facility/kitchen/chit";
import { IChit, usePOSPrinter } from "hooks/usePOSPrinter/usePOSPrinter";
import PrintChit from "components/printChit/PrintChit";

import { Select } from "components/select/index";
import MergeSeats, { IMergeSeatsState } from "components/mergeSeats/MergeSeats";
import EditSeatDetails from "components/editSeatDetails/EditSeatDetails";
import { ICustomer } from "redux/reducers/models/customer";
import { NewBadgeGroup } from "components/badgeGroup/NewBadgeGroup";
import TableServiceKitchenChitModal from "../../TableServiceKitchenChitModal/TableServiceKitchenChitModal";
import MoveSeats, { IMoveSeatsState } from "components/moveSeats/MoveSeats";
import TransferTableSheet, { ITransferTableSheetState } from "components/transferTableSheet/TransferTableSheet";
import { IUser } from "redux/reducers/models/user";
import { GetFacilityAdmin } from "api/rpc/2024-04/facilityAdmin/client/admin/admin";
import TableServiceMoveLineItemsModal from "containers/facility/tableServiceMoveLineItemsModal";
import { isSeatAbleToMoveLineItems } from "../../LineItemModals/TableServiceMoveLineItemsModal";
import SplitLineItemsModal from "../../LineItemModals/splitLineItemsModal/SplitLineItemsModal";
import Divider from "components/divider";
import { PutVoidCarts } from "api/rpc/2024-04/facilityAdmin/order/cart/cart";
import Portal from "elements/Portal";
import LeagueSelectionModal from "components/leagueSelectionModal/LeagueSelectionModal";
import {
  GetTable,
  GetTableReceipt,
  ITable,
  PutCloseTable,
  PutMoveSeats,
  PutTable,
} from "api/rpc/2024-04/facilityAdmin/tables/tables";
import { FireKitchenChit } from "api/rpc/2024-04/facilityAdmin/facility/kitchen/meals";
import InvoiceModal from "components/invoiceModal/InvoiceModal";
import { PostMigrateCart } from "api/rpc/2024-04/facilityAdmin/order/invoice";

import { useTranslation } from "react-i18next";
import { TFunction } from "i18next";
import useCurrencyFacility from "hooks/useCurrency/useCurrencyFacility";
import TextField from "components/form/textField/TextField";
import { IFolder } from "api/rpc/2024-04/facilityAdmin/product/folder";
import { applyInventoryQuantitiesToProducts, fetchTrackedInventoryQuantities } from "helpers/registerInventory";
import { getStoredProductFolder, upsertStoredProductFolder } from "helpers/productFoldersStorage";
import { ILoyaltyCustomerExtended } from "pages/secure/facility/settings/loyaltyProgram/loyaltyTabs/LoyaltyCustomers";
import { IOffer } from "redux/reducers/models/loyalty";
import { GetLoyaltyCustomer } from "api/rpc/2024-04/facilityAdmin/customer/loyaltyCustomer";
import RedeemPointsModal from "pages/secure/facility/register/registerNew/loyaltyPoints/RedeemPointsModal";
import RedeemTierPointsModal from "pages/secure/facility/register/registerNew/loyaltyPoints/RedeemTierPointsModal";
import { PostLoyaltyProgramDiscount } from "api/rpc/2024-04/facilityAdmin/discount/loyaltyProgramDiscount";
import {
  DeleteServiceFeeLineItem,
  PostCheckout,
  PostServiceFeeLineItem,
  PutCart,
  GetCart,
  PostMerge,
  PutClearCart,
  PostCart,
} from "api/rpc/2024-04/facilityAdmin/cart/cart";
import {
  isAutoDiscountsDisabled,
  nextDisableAutoDiscountsValue,
  showDisableDiscountsOption,
} from "utils/cartDiscounts";
import CustomerDepositsModal from "pages/secure/facility/register/registerNew/customerDepositsModal/CustomerDepositsModal";
import useOutstandingBalancePopup from "pages/secure/facility/register/registerNew/outstandingBalancePopup/useOutstandingBalancePopup";
import { IBookingDeposit } from "api/rpc/2024-04/facilityAdmin/deposit/deposit";
import CartAuditTrailDrawer from "pages/secure/facility/register/registerNew/CartAuditTrailDrawer";
import { IStub } from "redux/reducers/models/ticket";
import {
  buildRedemptionVariantsFromRedeemedStubs,
  expandTicketStubIds,
  getMaxRedemptionQuantity,
  getTicketRedemptionQuantity,
  isMultiUseTicket,
  stubHasRedemptionProducts,
  TicketRedemptionQuantityMap,
} from "helpers/ticketRedemption";
import TicketRedemptionQuantityInput from "components/ticketRedemption/TicketRedemptionQuantityInput";
import "components/ticketRedemption/ticketRedemption.scss";
import RedeemCashbackPointsModal from "pages/secure/facility/register/registerNew/loyaltyPoints/RedeemCashbackPointsModal";
// import { PutMarkPaidReservationBooking } from "api/rpc/2024-04/facilityAdmin/reservation/reservation";

export type TGiftCardParam = {
  product_id: number;
  cart_line_item_id: number;
  code: string;
  pin: number;
  random: boolean;
  balance: number;
  reload: number;
  gift_card_restrict_facility?: boolean;
  gift_card_expiry_type?: string;
  gift_card_expiry_years?: number;
  override_expiry?: boolean;
  expires_at?: string;
};

interface IProps {
  selectCourse: (id: number) => void;
  selectedCourseId: number;
  order: IOrder;
  setTableState: React.Dispatch<React.SetStateAction<ITableServiceState>>;
  navigateToTableSelection: () => void | Promise<void>;
  cartLoadingMessage: string;
  selectedFolder: IFolder;
  isOverlay?: boolean;
  mobileSeatBar?: boolean;
  allowLineItemAutoScroll?: boolean;
  flyToCartTargetRef?: React.RefObject<HTMLDivElement>;
  onSearchProduct?: () => void;
}

interface IRedeemTicketModalState {
  isOpen: boolean;
  selectedTab: number;
  ticketCode: string;
  availableTickets: any[];
  selectedCustomerTickets: any[];
  selectedCustomerTicketQuantities: TicketRedemptionQuantityMap;
  scannedTickets: any[];
  scannedTicketQuantities: TicketRedemptionQuantityMap;
  ticketOffset: number;
}

const TICKET_LIMIT = 50;

interface IActionsState {
  showActionsModal: boolean;
}
interface ILineItemState {
  showEditLineItemModal: boolean;
  selectedLineItem: ICartLineItem;
}

interface IDiscountState {
  selectedDiscount: IDiscountLines;
  showModal: boolean;
  parentLineItemId: number;
}

interface ISeatDiscountModalState {
  isOpen: boolean;
  selectedDiscountId: number;
  selectedDiscount: IDiscount;
  noteDiscount: string;
}

const initialSeatDiscountModalState: ISeatDiscountModalState = {
  isOpen: false,
  selectedDiscountId: -1,
  selectedDiscount: null,
  noteDiscount: "",
};

interface IPaymentState {
  paymentModalVisible: boolean;
  paymentAmount: string;
  paymentOption: Record<string, any>;
  paymentInProgress: boolean;

  clientSecret: string;
  manualCardModalVisible: boolean;

  sellGiftCardsActive: boolean;
  giftCardModalVisible: boolean;
  gift_cards: Array<TGiftCardParam>;

  changeDue: number;
  changeDueVisible: boolean;

  accountsVisible: boolean;
  accounts: Record<string, any>[];
  selectedAccount: Record<string, any>;

  leagueFeesActive: boolean;
  leagueFeeProducts: Array<ICartLineItem>;
  selectedLeagues: Array<number>;

  roomChargeSheetVisible: boolean;
  roomOccupantSearchQuery: string;
  roomOccupantsSearchResults: IOccupant[];
  selectedOccupant: IOccupant;
}

export default function TableServiceCart(props: IProps) {
  const {
    selectedCourseId,
    selectCourse,
    order,
    setTableState,
    navigateToTableSelection,
    cartLoadingMessage,
    selectedFolder,
    isOverlay,
    mobileSeatBar,
    allowLineItemAutoScroll = true,
    flyToCartTargetRef,
    onSearchProduct,
  } = props;
  const {
    cartStore: { cart, activeTable },
    cartStore,
    facilityStore,
    terminalStore,
    authStore,
  } = useAppSelector(store => store);
  const permissions = authStore?.user?.permissions;
  const dispatch = useAppDispatch();
  const { loadingVariants, lineItemsUpdating, addLineItemUpdating, removeLineItemUpdating, registerState, updateRegisterState } =
    useRegisterContext();
  const elements = useElements();
  const { printChits } = usePOSPrinter();
  const { Option } = Select;
  const { t } = useTranslation();
  const { getCurrencySymbol } = useCurrencyFacility();

  const [viewCartAudit, setViewCartAudit] = useState<boolean>(false);
  const [addingSeat, setAddingSeat] = useState(false);
  const seatsScrollRef = useRef<HTMLDivElement>(null);
  const seatsBarRef = useRef<HTMLDivElement>(null);
  const pendingSeatsScrollToEndRef = useRef(false);

  const updateSeatsScrollState = useCallback(() => {
    const scrollEl = seatsScrollRef.current;
    const barEl = seatsBarRef.current;
    if (!scrollEl || !barEl) {
      return;
    }

    const hasOverflow = scrollEl.scrollWidth > scrollEl.clientWidth + 1;
    const canScrollLeft = scrollEl.scrollLeft > 1;
    const canScrollRight = scrollEl.scrollLeft + scrollEl.clientWidth < scrollEl.scrollWidth - 1;

    if (hasOverflow) {
      barEl.setAttribute("data-has-overflow", "");
    } else {
      barEl.removeAttribute("data-has-overflow");
    }

    if (hasOverflow && canScrollLeft) {
      barEl.setAttribute("data-can-scroll-left", "");
    } else {
      barEl.removeAttribute("data-can-scroll-left");
    }

    if (hasOverflow && canScrollRight) {
      barEl.setAttribute("data-can-scroll-right", "");
    } else {
      barEl.removeAttribute("data-can-scroll-right");
    }
  }, []);

  const syncMobileSeatCellSize = useCallback(() => {
    const barEl = seatsBarRef.current;
    const container = seatsScrollRef.current?.querySelector(".active-table-seats-container");
    if (!barEl || !container) {
      return;
    }

    const buttons = container.querySelectorAll<HTMLElement>(".active-table-seats-button");
    if (buttons.length === 0) {
      barEl.style.removeProperty("--seat-cell-size");
      return;
    }

    container.setAttribute("data-measuring", "");
    let maxSize = 36;

    buttons.forEach(button => {
      const { width, height } = button.getBoundingClientRect();
      maxSize = Math.max(maxSize, Math.ceil(width), Math.ceil(height));
    });

    container.removeAttribute("data-measuring");
    const nextSize = `${maxSize}px`;
    if (barEl.style.getPropertyValue("--seat-cell-size") !== nextSize) {
      barEl.style.setProperty("--seat-cell-size", nextSize);
    }
  }, []);

  useEffect(() => {
    if (!mobileSeatBar) {
      return;
    }

    const scrollEl = seatsScrollRef.current;
    if (!scrollEl) {
      return;
    }

    updateSeatsScrollState();

    const handleScroll = () => updateSeatsScrollState();
    scrollEl.addEventListener("scroll", handleScroll, { passive: true });

    const resizeObserver = new ResizeObserver(() => {
      syncMobileSeatCellSize();
      updateSeatsScrollState();
    });
    resizeObserver.observe(scrollEl);
    if (seatsBarRef.current) {
      resizeObserver.observe(seatsBarRef.current);
    }
    const containerEl = scrollEl.firstElementChild;
    if (containerEl) {
      resizeObserver.observe(containerEl);
    }

    requestAnimationFrame(() => {
      syncMobileSeatCellSize();
      updateSeatsScrollState();
    });

    return () => {
      scrollEl.removeEventListener("scroll", handleScroll);
      resizeObserver.disconnect();
    };
  }, [activeTable?.carts, mobileSeatBar, syncMobileSeatCellSize, updateSeatsScrollState]);

  useEffect(() => {
    if (!mobileSeatBar) {
      return;
    }

    const scrollEl = seatsScrollRef.current;
    if (!scrollEl || !cart?.token) {
      return;
    }

    if (pendingSeatsScrollToEndRef.current) {
      pendingSeatsScrollToEndRef.current = false;
      const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      requestAnimationFrame(() => {
        scrollEl.scrollTo({
          left: scrollEl.scrollWidth,
          behavior: prefersReducedMotion ? "auto" : "smooth",
        });
        updateSeatsScrollState();
      });
      return;
    }

    const selectedButton = scrollEl.querySelector(".active-table-seats-button-selected");
    if (!selectedButton) {
      return;
    }

    const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    selectedButton.scrollIntoView({
      inline: "nearest",
      block: "nearest",
      behavior: prefersReducedMotion ? "auto" : "smooth",
    });
    requestAnimationFrame(() => updateSeatsScrollState());
  }, [cart?.token, activeTable?.carts?.length, mobileSeatBar, updateSeatsScrollState]);

  function handleSeatsChevronScroll(direction: "left" | "right") {
    const scrollEl = seatsScrollRef.current;
    if (!scrollEl) {
      return;
    }

    const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    scrollEl.scrollBy({
      left: direction === "left" ? -120 : 120,
      behavior: prefersReducedMotion ? "auto" : "smooth",
    });
  }

  useEffect(() => {
    if (!isOverlay) {
      return;
    }

    const lineItemsScroller = document.querySelector(".table-service-cart-line-items");
    if (lineItemsScroller) {
      lineItemsScroller.scrollTop = 0;
    }
  }, [isOverlay]);

  const [lineItemState, setLineItemState] = useState<ILineItemState>({
    showEditLineItemModal: false,
    selectedLineItem: null,
  });
  const [discountState, setDiscountState] = useState<IDiscountState>({
    selectedDiscount: null,
    showModal: false,
    parentLineItemId: null,
  });
  const [seatDiscountModal, setSeatDiscountModal] = useState<ISeatDiscountModalState>(initialSeatDiscountModalState);

  const [paymentState, setPaymentState] = useState<IPaymentState>({
    paymentModalVisible: false,
    paymentAmount: "",
    paymentOption: null,
    paymentInProgress: false,

    clientSecret: "",
    manualCardModalVisible: false,

    giftCardModalVisible: false,
    gift_cards: null,
    sellGiftCardsActive: false,

    changeDue: null,
    changeDueVisible: false,

    accountsVisible: false,
    accounts: [],
    selectedAccount: undefined,

    leagueFeesActive: false,
    leagueFeeProducts: [],
    selectedLeagues: null,

    roomChargeSheetVisible: false,
    roomOccupantSearchQuery: "",
    roomOccupantsSearchResults: [],
    selectedOccupant: null,
  });

  const [actionsState, setActionsState] = useState<IActionsState>({
    showActionsModal: false,
  });

  const [redeemTicketModal, setRedeemTicketModal] = useState<IRedeemTicketModalState>({
    isOpen: false,
    selectedTab: 0,
    ticketCode: "",
    availableTickets: [],
    selectedCustomerTickets: [],
    selectedCustomerTicketQuantities: {},
    scannedTickets: [],
    scannedTicketQuantities: {},
    ticketOffset: 0,
  });

  const handleOpenRedeemTicket = async () => {
    let availableTickets: any[] = [];
    if (cart?.customer?.id) {
      const ticketRes = await GetTicketStub(
        { customer_id: cart.customer.id, status: "valid", extended: true, limit: TICKET_LIMIT, offset: 0 },
        true,
      );
      if (ticketRes.status === StatusCode.OK) {
        availableTickets = ticketRes.data;
      }
    }
    setRedeemTicketModal(prev => ({
      ...prev,
      isOpen: true,
      availableTickets,
      selectedCustomerTickets: [],
      selectedCustomerTicketQuantities: {},
      scannedTickets: [],
      scannedTicketQuantities: {},
      ticketCode: "",
      selectedTab: 0,
      ticketOffset: 0,
    }));
  };

  const handleAvailableTicketsOffset = async (direction: "prev" | "next") => {
    if (!cart?.customer?.id) {
      return;
    }
    const newOffset =
      direction === "prev"
        ? redeemTicketModal.ticketOffset - TICKET_LIMIT
        : redeemTicketModal.ticketOffset + TICKET_LIMIT;
    if (newOffset < 0) {
      return;
    }
    const ticketRes = await GetTicketStub(
      { customer_id: cart.customer.id, status: "valid", extended: true, limit: TICKET_LIMIT, offset: newOffset },
      true,
    );
    if (ticketRes.status === StatusCode.OK) {
      setRedeemTicketModal(prev => ({
        ...prev,
        availableTickets: ticketRes.data,
        ticketOffset: newOffset,
      }));
    }
  };

  const addRedeemedStubsToCartMultiple = async (
    redeemedStubs: IStub[],
    cartId?: number,
  ): Promise<boolean> => {
    if (!redeemedStubs || !redeemedStubs.length) {
      return true;
    }
    if (!cartId) {
      dispatch(showError(t("Failed to add redemption products to cart")));
      return false;
    }

    const variantsToAdd = buildRedemptionVariantsFromRedeemedStubs(redeemedStubs);
    const hasProducts = redeemedStubs.some(stub => stubHasRedemptionProducts(stub));

    if (variantsToAdd.length === 0) {
      if (hasProducts) {
        dispatch(showError(t("Failed to add redemption products to cart")));
        return false;
      }
      return true;
    }

    const updatedCartRes = await PostLineItemToCart({ cart_id: cartId, variants: variantsToAdd }, true);
    if (updatedCartRes?.status === StatusCode.OK && updatedCartRes?.data) {
      void dispatch(loadTableCart({ tableCart: updatedCartRes.data }, false));
      void updateActiveTable(updatedCartRes.data);
      return true;
    }

    dispatch(showError(t("Failed to add redemption products to cart")));
    return false;
  };

  const handleScanTicket = async () => {
    const code = redeemTicketModal.ticketCode.trim();
    if (!code) {
      dispatch(showError(t("Please enter a ticket code")));
      return;
    }

    if (redeemTicketModal.scannedTickets.some((t: any) => t.code === code)) {
      dispatch(showError(t("Ticket already scanned")));
      return;
    }

    const validateRes = await GetTicketValidate({ code }, true);
    if (validateRes.status !== StatusCode.OK) {
      dispatch(showError(typeof validateRes.data === "string" ? validateRes.data : t("Invalid ticket code")));
      return;
    }
    const stub = validateRes.data?.stub || validateRes.data;
    if (stub) {
      setRedeemTicketModal(prev => ({
        ...prev,
        scannedTickets: [...prev.scannedTickets, stub],
        scannedTicketQuantities: isMultiUseTicket(stub)
          ? { ...prev.scannedTicketQuantities, [stub.id]: 1 }
          : prev.scannedTicketQuantities,
        ticketCode: "",
      }));
    }
  };

  const removeScannedTicket = (index: number) => {
    setRedeemTicketModal(prev => {
      const removedStub = prev.scannedTickets[index];
      const scannedTicketQuantities = { ...prev.scannedTicketQuantities };
      if (removedStub?.id) {
        delete scannedTicketQuantities[removedStub.id];
      }

      return {
        ...prev,
        scannedTickets: prev.scannedTickets.filter((_, i) => i !== index),
        scannedTicketQuantities,
      };
    });
  };

  const handleRedeemTicket = async () => {
    const cartId = cart?.id;
    const customerId = cart?.customer?.id ?? undefined;

    if (redeemTicketModal.selectedTab === 0) {
      if (redeemTicketModal.scannedTickets.length === 0) {
        dispatch(showError(t("Please scan at least one ticket")));
        return;
      }
      const stubIds = expandTicketStubIds(redeemTicketModal.scannedTickets as IStub[], redeemTicketModal.scannedTicketQuantities);
      const redeemRes = await PutTicketStubRedeemMultiple(
        { ticket_stub_ids: stubIds, customer_id: customerId },
        true,
      );
      if (redeemRes.status !== StatusCode.OK) {
        dispatch(showError(typeof redeemRes.data === "string" ? redeemRes.data : t("Error redeeming tickets")));
        return;
      }

      const cartAddOk = await addRedeemedStubsToCartMultiple(redeemRes.data as IStub[], cartId);
      if (cartAddOk) {
        dispatch(showSuccess(t("Ticket redeemed successfully")));
      }
      setRedeemTicketModal(prev => ({
        ...prev,
        isOpen: false,
        scannedTickets: [],
        scannedTicketQuantities: {},
        ticketCode: "",
      }));
    } else {
      if (redeemTicketModal.selectedCustomerTickets.length === 0) {
        dispatch(showError(t("Please select at least one ticket")));
        return;
      }
      const stubIds = expandTicketStubIds(
        redeemTicketModal.selectedCustomerTickets as IStub[],
        redeemTicketModal.selectedCustomerTicketQuantities,
      );
      const redeemRes = await PutTicketStubRedeemMultiple(
        { ticket_stub_ids: stubIds, customer_id: customerId },
        true,
      );
      if (redeemRes.status !== StatusCode.OK) {
        dispatch(showError(typeof redeemRes.data === "string" ? redeemRes.data : t("Error redeeming tickets")));
        return;
      }

      const cartAddOk = await addRedeemedStubsToCartMultiple(redeemRes.data as IStub[], cartId);
      if (cartAddOk) {
        dispatch(showSuccess(t("Ticket redeemed successfully")));
      }
      setRedeemTicketModal(prev => ({
        ...prev,
        isOpen: false,
        selectedCustomerTickets: [],
        selectedCustomerTicketQuantities: {},
      }));
    }
  };

  const [manualStripeState, setManualStripeState] = useState({
    clientSecret: "",
    visible: false,
    transaction: undefined,
    elementComplete: {
      cardNumber: false,
      cardExpiry: false,
      cardCvc: false,
    },
  });

  const [submitTrigger, setSubmitTrigger] = useState<boolean>(false);
  const [manualProcessing, setManualProcessing] = useState<boolean>(false);

  const [stripePaymentState, setStripePaymentState] = useState<IStripePaymentState>({
    onCancel: () => { },
    onOk: () => { },
    cancelText: "",
    okText: "",
    sheetVisible: false,
    titleText: "",
    message: "",
    convertedCode: "",
    processing: false,
    success: false,
  });

  //Credit Book payment Method
  const {
    state: invoiceModal,
    updateModal: updateInvoiceModal,
    closeModal: closeInvoiceModal,
  } = useModal<{ selectedInvoice: IInvoice }>({ selectedInvoice: null, clearOnClose: false });

  //Invoice payment method
  const {
    state: modalCreditBook,
    updateModal: updateCreditBook,
    closeModal: closeCreditBook,
  } = useModal<{ selectedCreditBook: IPrizeAccount }>({ selectedCreditBook: null });

  //Order Complete
  const { state: orderComplete, updateModal: updateOrderComplete, closeModal: closeOrderComplete } = useModal();
  const { openIfNeeded: openFutureBookingPricingModalIfNeeded, modal: futureBookingPricingModal } =
    useFutureBookingPricingModal();
  //Close Table
  const {
    state: closeTable,
    updateModal: updateCloseTable,
    closeModal: cancelCloseTable,
  } = useModal<{
    seatsOpen: boolean;
    partiallyPaidSeats: boolean;
    voidSeats: boolean;
    cancel_reason: string;
    loadingMessage: string;
  }>({
    seatsOpen: false,
    partiallyPaidSeats: false,
    voidSeats: false,
    cancel_reason: "Server Error",
    loadingMessage: "",
  });

  //Print Chits
  const { state: printChitsState, updateModal: updatePrintChits, closeModal: cancelPrintChits } = useModal();
  //Send Chits
  const { state: sendChits, updateModal: updateSendChits, closeModal: cancelSendChits } = useModal();
  const [forceRefreshChits, setForceRefreshChits] = useState<boolean>(true);

  //Void Seat
  const {
    state: voidSeat,
    updateModal: updateVoidSeat,
    closeModal: closeVoidSeat,
  } = useModal<{ cancel_reason: string }>({ cancel_reason: "Server Error" });

  //Close Seat
  const { state: closeSeat, updateModal: updateCloseSeat, closeModal: closeCloseSeat } = useModal();
  //Clear Seat
  const { state: clearSeat, updateModal: updateClearSeat, closeModal: closeClearSeat } = useModal();
  //Merge Seats
  const { state: mergeSeats, updateModal: updateMergeSeats, closeModal: closeMergeSeats } = useModal();
  //Move Seats
  const { state: moveSeats, updateModal: updateMoveSeats, closeModal: closeMoveSeats } = useModal();
  //Seat Details
  const {
    state: seatDetails,
    updateModal: updateSeatDetails,
    closeModal: closeSeatDetails,
  } = useModal<{ customer: ICustomer; description: string }>({ customer: null, description: "" });

  //View Chits
  const { state: viewChits, updateModal: updateViewChits, closeModal: closeViewChits } = useModal();

  //Move Line Items
  const { state: moveItems, updateModal: updateMoveItems, closeModal: closeMoveItems } = useModal();

  //Split Line Items
  const { state: splitItems, updateModal: updateSplitItems, closeModal: closeSplitItems } = useModal();

  // Add / edit order notes
  const {
    state: viewNoteModal,
    updateModal: updateViewNoteModal,
    closeModal: closeViewNoteModal,
  } = useModal<{ addNote: string }>({ addNote: "", clearOnClose: false });

  //Transfer Table
  const { state: transferTable, updateModal: updateTransferTable } = useModal<{ users: Array<IUser> }>({
    users: [],
    clearOnClose: false,
  });

  //Loyalty Points
  const {
    state: redeemPointsModal,
    updateModal: updateRedeemPointsModal,
    closeModal: closeRedeemPointsModal,
  } = useModal();
  const [loyaltyCustomer, setLoyaltyCustomer] = useState<
    ILoyaltyCustomerExtended & { points_available?: number; points_to_earn?: number }
  >(null);

  //Deposits
  const { state: customerDepositsModal, updateModal: updateCustomerDepositsModal, closeModal: closeCustomerDepositsModal } = useModal();

  const { checkOutstandingBalance, outstandingBalancePopup } = useOutstandingBalancePopup();

  const {
    StripeTerminalSheet,
    StripeTerminalRefundSheet,
    processPayment,
    processRefund,
    paymentStatus,
    order: tempStripePaymentOrder,
  } = useStripeTerminalPayment();

  const [showRefundBeforeVoidSeat, setShowRefundBeforeVoidSeat] = useState(false);
  const [refundingPayments, setRefundingPayments] = useState(false);

  useEffect(() => {
    void loadFacilityUsers();
  }, []);

  useEffect(() => {
    if (registerState.dynamicPriceLineItem) {
      setLineItemState(prevState => ({
        ...prevState,
        showEditLineItemModal: true,
        selectedLineItem: registerState.dynamicPriceLineItem,
      }));
      updateRegisterState({ dynamicPriceLineItem: null });
    }
  }, [registerState.dynamicPriceLineItem]);

  useEffect(() => {
    if (cartStore?.activeTable) {
      const closeTable = cartStore?.activeTable?.carts?.some(cart => cart.status === "open");
      if (!closeTable) {
        updateCloseTable({ isOpen: true });
      }

      // const allSeatsPaid = cartStore?.activeTable?.carts?.every(cart => cart?.order_financial_status === "paid");
      // if (allSeatsPaid && activeTable?.id) {
      //     void markReservationPaid();
      //   }
    }
  }, [cartStore?.activeTable]);

  useEffect(() => {
    if ((paymentStatus === "partial_payment" || paymentStatus === "paid") && tempStripePaymentOrder !== null) {
      void updateOrder(tempStripePaymentOrder.id as number, true);
      if (order.balance > 0) {
        setPaymentState(prevState => ({ ...prevState, paymentAmount: order.balance.toFixed(2) }));
      }
    }
  }, [paymentStatus]);

  useEffect(() => {
    if (order) {
      if (order.balance > 0 && order?.financial_status !== "unpaid") {
        setPaymentState(prevState => ({ ...prevState, paymentAmount: order.balance.toFixed(2) }));
      }
    }
  }, [order]);

  useEffect(() => {
    if (cart) {
      setPaymentState(prevState => ({
        ...prevState,
        paymentAmount:
          order?.balance && order?.financial_status !== "unpaid"
            ? order?.balance?.toFixed(2)
            : cart?.total_price.toFixed(2),
        gift_cards: null,
        selectedLeagues: null,
      }));

      if (loyaltyCustomer) {
        const totalBalance = loyaltyCustomer?.points_balance;
        const totalPointsUsed = cart?.discount_lines
          ?.filter(discount => discount?.loyalty_points_reward_id)
          ?.reduce((total, discount) => total + discount?.loyalty_points_used, 0);

        let totalPointsToEarn = 0;
        const loyaltyOffers = facilityStore?.loyaltyProgramOffers?.filter(offer => offer?.active);
        //Calculate points to earn
        if (totalPointsUsed <= 0 && loyaltyOffers?.length > 0) {
          loyaltyOffers?.forEach(offer => {
            if (offer?.type === "amount_spent") {
              const pointsEarned = processAmountSpentOffer(offer);
              totalPointsToEarn += pointsEarned;
            }
          });
          //Add items with loyalty points override
          cart?.line_items?.forEach(lineItem => {
            if (lineItem?.loyalty_points_override != null) {
              //Don't count discounts items if the loyalty program doesn't allow it
              if (facilityStore?.loyaltyProgram?.exclude_discounted_items) {
                const foundDiscount = cart?.discount_lines?.some(line => line?.cart_line_item_id === lineItem?.id);
                if (foundDiscount) {
                  return;
                }
              }
              totalPointsToEarn += lineItem?.loyalty_points_override * lineItem?.quantity;
            }
          });
        }
        setLoyaltyCustomer(prev => ({
          ...prev,
          points_available: totalBalance - totalPointsUsed,
          points_to_earn: totalPointsToEarn,
        }));
      }
    } else {
      setPaymentState(prevState => ({ ...prevState, paymentAmount: "0.00" }));
    }
  }, [cartStore?.cart, facilityStore?.loyaltyProgramOffers, facilityStore?.loyaltyProgram]);

  //Get loyalty customer information
  useEffect(() => {
    const source = axios.CancelToken.source();
    if (cart?.customer && !(order?.financial_status === "partially_paid" || cart?.status === "void")) {
      setLoyaltyCustomer(null);
      void getLoyaltyCustomer(cart?.customer_id, source.token);
    } else {
      setLoyaltyCustomer(null);
    }
    return () => source.cancel();
  }, [cart?.customer?.id]);

  useEffect(() => {
    if (paymentState.selectedAccount || modalCreditBook.selectedCreditBook || invoiceModal.selectedInvoice) {
      void handleProcessPayment();
    }
    return () => {
      setPaymentState(prevState => ({ ...prevState, selectedAccount: undefined }));
      updateCreditBook({ selectedCreditBook: null });
      updateInvoiceModal({ selectedInvoice: null });
    };
  }, [paymentState.selectedAccount, modalCreditBook.selectedCreditBook, invoiceModal.selectedInvoice]);

  useEffect(() => {
    const source = axios.CancelToken.source();
    let mounted = true;
    let timeoutId: number = null;
    if (mounted === true) {
      timeoutId = window.setTimeout(() => {
        void searchForRoomOccupants(mounted, paymentState?.roomOccupantSearchQuery, source.token);
      }, 2000);
    }
    return () => {
      mounted = false;
      clearTimeout(timeoutId);
      setPaymentState(prevState => ({ ...prevState, roomOccupantsSearchResults: [] }));
      source.cancel("Cancelled");
    };
  }, [paymentState.roomOccupantSearchQuery]);

  //Update reader on cart change
  useEffect(() => {
    if (cartStore?.cart?.line_items && terminalStore?.reader) {
      if (cartStore?.cart?.total_price > 0) {
        void setReaderDisplay(convertOrderIntoDisplayInfo(cartStore?.cart, order));
      }
    }
  }, [cartStore?.cart, terminalStore?.reader]);

  async function loadFacilityUsers() {
    const usersRes = await GetFacilityAdmin(null, false);
    if (usersRes.status !== StatusCode.OK) {
      dispatch(showError(t("secure.facility.table_service.table_service_cart.table_service_cart.001")));
      return;
    }

    void updateTransferTable({ users: usersRes?.data as unknown as IUser[] });
  }

  async function loadRoomOccupants(roomOccupantSearchQuery: string, cancelToken: CancelToken) {
    const roomOccupantsRes = await GetRoomOccupants({ search: roomOccupantSearchQuery }, true, cancelToken);

    if (roomOccupantsRes.status !== StatusCode.OK && roomOccupantsRes.message !== "Cancelled") {
      dispatch(showError(roomOccupantsRes.message));
      return;
    }

    return roomOccupantsRes;
  }

  async function searchForRoomOccupants(mounted: boolean, roomOccupantSearchQuery: string, cancelToken: CancelToken) {
    try {
      if (roomOccupantSearchQuery === "") {
        if (mounted) {
          setPaymentState(prevState => ({ ...prevState, roomOccupantsSearchResults: [] }));
        }
      } else {
        const res = await loadRoomOccupants(roomOccupantSearchQuery, cancelToken);
        if (mounted && res?.status === StatusCode.OK && res?.data) {
          const occupants = res.data.map(occupant => {
            return {
              reservation_number: occupant.reservation_number ?? "",
              room_number: occupant.room_number ?? "",
              res_status: occupant.res_status,
              guest_name: occupant.guest_name ?? "",
              credit_limit: occupant.credit_limit,
            };
          });
          setPaymentState(prevState => ({ ...prevState, roomOccupantsSearchResults: occupants }));
        }
      }
    } catch (error) {
      console.error(error);
      setPaymentState(prevState => ({ ...prevState }));
    }
    setPaymentState(prevState => ({
      ...prevState,
      selectedOccupant: null,
    }));
  }

  // async function markReservationPaid() {
  //   const res = await PutMarkPaidReservationBooking({ table_id: activeTable?.id }, false);
  //   if (res?.status !== StatusCode.OK) {
  //     dispatch(showError(typeof res?.data === "string" ? res?.data : t("Error marking reservation as paid")));
  //     return;
  //   }
  // }

  const handleStripeError = (message: string, sheetInfo: sheetInfo) => {
    //set sheet
    setStripePaymentState(prevState => ({
      ...prevState,
      onCancel: () => {
        sheetInfo.onCancel();
        setStripePaymentState(prevState => ({ ...prevState, sheetVisible: false }));
      },
      onOk: () => {
        sheetInfo.onOk();
        setStripePaymentState(prevState => ({
          ...prevState,
          sheetVisible: true,
          onCancel: undefined,
          okText: t("secure.facility.table_service.table_service_cart.table_service_cart.002"),
          processing: true,
          onOk: async () => {
            setStripePaymentState(prevState => ({
              ...prevState,
              sheetVisible: false,
              onCancel: undefined,
              okText: undefined,
              processing: false,
              onOk: () => { },
              titleText: "",
              success: false,
              message: "",
            }));
            await clearReaderDisplay();
          },
          titleText: t("secure.facility.table_service.table_service_cart.table_service_cart.003"),
          message: t("secure.facility.table_service.table_service_cart.table_service_cart.004"),
        }));
      },
      cancelText: sheetInfo.cancelText,
      okText: sheetInfo.okText,
      sheetVisible: true,
      titleText: sheetInfo.title,
      message: sheetInfo.message,
      convertedCode: sheetInfo.convertedErrorCode,
      success: false,
      processing: false,
    }));
  };

  const handleStripeSuccess = (message?: string, order_id?: number) => {
    setStripePaymentState(prevState => ({
      ...prevState,
      sheetVisible: true,
      onCancel: undefined,
      okText: t("secure.facility.table_service.table_service_cart.table_service_cart.005"),
      //resets state
      onOk: () => {
        setStripePaymentState(prevState => ({
          ...prevState,
          sheetVisible: false,
          onCancel: undefined,
          okText: undefined,
          processing: false,
          onOk: () => { },
          titleText: "",
          message: "",
        }));
      },
      processing: false,
      success: true,
      titleText: t("secure.facility.table_service.table_service_cart.table_service_cart.006"),
      message: t("secure.facility.table_service.table_service_cart.table_service_cart.007"),
    }));
    void updateOrder(order_id, true);
    dispatch(showSuccess(t("secure.facility.table_service.table_service_cart.table_service_cart.007")));
  };

  function handleSelectSeat(cart: ICart) {
    if (cart) {
      ReactDOM.unstable_batchedUpdates(() => {
        setTableState(prevState => ({
          ...prevState,
          order:
            cart?.order?.financial_status === "partially_paid" || cart?.order?.financial_status === "unpaid"
              ? cart?.order
              : undefined,
        }));
        void dispatch(loadTableCart({ tableCart: cart }, false));
      });
    }
  }

  async function handleAddSeat() {
    if (activeTable && !addingSeat) {
      setAddingSeat(true);
      const postRes = await PostCart({ type: "tab", table_id: activeTable?.id }, false);
      if (postRes.status !== StatusCode.OK) {
        void dispatch(showError(t("secure.facility.table_service.table_service_cart.table_service_cart.008")));
        setAddingSeat(false);
        return;
      }

      ReactDOM.unstable_batchedUpdates(() => {
        const updatedTable = { ...activeTable };
        updatedTable.carts?.push(postRes?.data as ICart);
        void dispatch(setActiveTable(updatedTable));
        void dispatch(loadTableCart({ tableCart: postRes?.data as ICart }, false));
        pendingSeatsScrollToEndRef.current = true;
        setAddingSeat(false);
      });
    }
  }

  async function printReceipt(id: number, type: "cart" | "order") {
    const receiptRes = await GetReceipt({ id, type: type }, true);

    if (receiptRes.status === StatusCode.OK) {
      printDesktopReceipt(facilityStore.facility?.id, receiptRes.data.toString() as string);
    } else {
      dispatch(showError(t("secure.facility.table_service.table_service_cart.table_service_cart.009")));
    }
  }

  async function handleUpdateLineItem(updatedLineItem: TUpdatedLineItem) {
    const lineItemId = lineItemState?.selectedLineItem?.id;
    const lineItemParentId = lineItemState?.selectedLineItem?.parent_id;
    const cartId = lineItemState?.selectedLineItem?.cart_id;
    const selectedLineItem = lineItemState?.selectedLineItem;
    const newQuantity = Number(updatedLineItem.quantity);

    if (!canSetCartLineItemQuantity(permissions, newQuantity, selectedLineItem)) {
      dispatch(showError(t("You do not have permission to remove items from the cart.")));
      return;
    }

    if (newQuantity === 0) {
      await handleRemoveLineItem();
      return;
    }

    const lineItemPickedKeys = (({ quantity, price, kitchen_meal_id, note }) => ({
      quantity,
      price,
      kitchen_meal_id,
      note,
    }))(lineItemState?.selectedLineItem);
    let lineItemRes: IAPIResponse;
    const params = {
      quantity: Number(updatedLineItem.quantity),
      price: Number(updatedLineItem.price),
      kitchen_meal_id: updatedLineItem.courseId,
      note: updatedLineItem.note,
      tax_exemption_applied: updatedLineItem.taxExemptionApplied,
    };

    setLineItemState(prevState => ({ ...prevState, showEditLineItemModal: false, selectedLineItem: null }));
    // Update line item if a change was made
    if (!isEqual(lineItemPickedKeys, params)) {
      void addLineItemUpdating(lineItemParentId ?? lineItemId);
      lineItemRes = await PutLineItemToCart({ id: lineItemState?.selectedLineItem?.id, ...params }, false);
      void removeLineItemUpdating(lineItemParentId ?? lineItemId);
      if (lineItemRes?.status !== StatusCode.OK) {
        dispatch(showError(t("secure.facility.table_service.table_service_cart.table_service_cart.010")));
        return;
      }
    }

    // Apply discount is discount was selected
    if (updatedLineItem?.discount) {
      void addLineItemUpdating(lineItemParentId ?? lineItemId);
      await handleApplyDiscounts(updatedLineItem, cartId, lineItemId);
      void removeLineItemUpdating(lineItemParentId ?? lineItemId);
    } else {
      //Line item updated and no discount applied, update cart in state
      if (lineItemRes) {
        ReactDOM.unstable_batchedUpdates(() => {
          void dispatch(loadTableCart({ tableCart: lineItemRes?.data as ICart }, false));
          void updateActiveTable(lineItemRes?.data as ICart);
        });
      } else {
        //Line item not updated and no discount applied, do nothing
        return;
      }
    }

    dispatch(showSuccess(t("secure.facility.table_service.table_service_cart.table_service_cart.011")));
  }

  async function handleApplyDiscounts(updatedLineItem: TUpdatedLineItem, cartId: number, lineItemId: number) {
    //Get modifier ids
    const modifierLineItemIds = getModifierLineItemIds(lineItemId);

    const discountRes = await PostDiscountLine(
      {
        discount_id: updatedLineItem?.discount?.id,
        cart_id: cartId,
        cart_line_item_id: lineItemId,
        value: updatedLineItem?.discount?.custom ? Number(updatedLineItem?.customDiscountAmount) : undefined,
        value_type: updatedLineItem?.discount?.custom ? updatedLineItem?.customDiscountType : undefined,
        modifier_line_item_ids:
          modifierLineItemIds?.length > 0 &&
            ((updatedLineItem?.discount?.custom && updatedLineItem?.customDiscountType == "percent") ||
              (!updatedLineItem?.discount?.custom && updatedLineItem?.discount?.value_type === "percent"))
            ? modifierLineItemIds
            : undefined,
      },
      false,
    );

    if (discountRes.status !== StatusCode.OK) {
      dispatch(showError(t("secure.facility.table_service.table_service_cart.table_service_cart.012")));
      return;
    }

    ReactDOM.unstable_batchedUpdates(() => {
      void dispatch(loadTableCart({ tableCart: discountRes?.data }, false));
      void updateActiveTable(discountRes?.data);
    });
  }

  function getModifierLineItemIds(lineItemParentId: number) {
    const cartLineItems = [...cart.line_items];
    return cartLineItems?.filter(lineItem => lineItem?.parent_id === lineItemParentId)?.map(lineItem => lineItem?.id);
  }

  async function handleRemoveLineItem() {
    if (!canRemoveCartLineItem(permissions, lineItemState?.selectedLineItem)) {
      dispatch(showError(t("You do not have permission to remove items from the cart.")));
      return;
    }

    const lineItemId = lineItemState?.selectedLineItem?.id;
    const lineItemParentId = lineItemState?.selectedLineItem?.parent_id;
    void addLineItemUpdating(lineItemParentId ?? lineItemId, "delete");
    setLineItemState(prevState => ({ ...prevState, showEditLineItemModal: false, selectedLineItem: null }));
    const lineItemRes = await DeleteLineItemToCart({ id: lineItemId }, false);
    void removeLineItemUpdating(lineItemParentId ?? lineItemId);
    if (lineItemRes?.status !== StatusCode.OK) {
      dispatch(showError(t("secure.facility.table_service.table_service_cart.table_service_cart.013")));
      return;
    }

    ReactDOM.unstable_batchedUpdates(() => {
      void dispatch(loadTableCart({ tableCart: lineItemRes?.data as ICart }, false));
      void updateActiveTable(lineItemRes?.data as ICart);
    });

    dispatch(showSuccess(t("secure.facility.table_service.table_service_cart.table_service_cart.014")));
  }

  function updateActiveTable(updatedCart: ICart) {
    if (activeTable) {
      const updatedActiveTable = { ...activeTable };
      const updatedTable = {
        ...updatedActiveTable,
        carts: activeTable?.carts?.map(tableCart => (tableCart?.id === updatedCart?.id ? updatedCart : tableCart)),
      };
      dispatch(setActiveTable(updatedTable));
    }
  }

  async function removeDiscountLine() {
    const selectedDiscount = { ...discountState?.selectedDiscount };
    //If modifier discount is being removed, show loader for the entire parent item + modifiers
    const selectedParentLineItemId = discountState?.parentLineItemId;

    void addLineItemUpdating(selectedParentLineItemId ?? selectedDiscount?.cart_line_item_id);
    setDiscountState(prevState => ({
      ...prevState,
      showModal: false,
      selectedDiscount: null,
    }));
    const res = await DeleteDiscountLine({ id: selectedDiscount?.id, cart_id: selectedDiscount?.cart_id }, false);
    void removeLineItemUpdating(selectedParentLineItemId ?? selectedDiscount?.cart_line_item_id);

    if (res?.status !== StatusCode.OK) {
      dispatch(showError(t("secure.facility.table_service.table_service_cart.table_service_cart.015")));
      return;
    }
    ReactDOM.unstable_batchedUpdates(() => {
      void dispatch(loadTableCart({ tableCart: res?.data as ICart }, false));
      void updateActiveTable(res?.data as ICart);
    });

    dispatch(showSuccess(t("secure.facility.table_service.table_service_cart.table_service_cart.016")));
  }

  async function handleApplySeatDiscount(customAmount?: string, typeFixed?: boolean) {
    if (!cart || !seatDiscountModal?.selectedDiscountId || seatDiscountModal.selectedDiscountId < 0) {
      return;
    }

    if (!(cart?.line_items?.length > 0)) {
      dispatch(showError(t("Cart does not contain any items")));
      return;
    }

    const type = typeFixed !== undefined ? (typeFixed ? "fixed_amount" : "percent") : undefined;
    const selectedDiscount = seatDiscountModal.selectedDiscount;
    const isFixedAmount = type === "fixed_amount" || (!type && selectedDiscount?.value_type === "fixed_amount");
    const isPercent = type === "percent" || (!type && selectedDiscount?.value_type === "percent");
    const discountId = seatDiscountModal.selectedDiscountId;
    const discountNotes = seatDiscountModal.noteDiscount;
    const parentLineItems = cart.line_items.filter(lineItem => !lineItem?.parent_id);

    parentLineItems.forEach(lineItem => {
      void addLineItemUpdating(lineItem?.id);
    });

    setSeatDiscountModal(initialSeatDiscountModalState);

    // Fixed seat discounts are split across line items by subtotal share so the
    // total discount equals the entered amount once (not once per line item).
    const fixedAmountsByLineItemId: Record<number, number> = {};
    if (isFixedAmount) {
      const totalFixedAmount = Number(
        customAmount !== undefined && customAmount !== "" ? customAmount : selectedDiscount?.value,
      );
      const lineSubtotals = parentLineItems.map(lineItem => Number(lineItem?.subtotal_price ?? lineItem?.price ?? 0));
      const cartSubtotal = lineSubtotals.reduce((sum, amount) => sum + amount, 0);

      if (!Number.isFinite(totalFixedAmount) || totalFixedAmount <= 0 || cartSubtotal <= 0) {
        parentLineItems.forEach(lineItem => {
          void removeLineItemUpdating(lineItem?.id);
        });
        dispatch(showError(t("secure.facility.table_service.table_service_cart.table_service_cart.012")));
        return;
      }

      let allocated = 0;
      parentLineItems.forEach((lineItem, index) => {
        const isLast = index === parentLineItems.length - 1;
        const amount = isLast
          ? Number((totalFixedAmount - allocated).toFixed(2))
          : Number(((totalFixedAmount * lineSubtotals[index]) / cartSubtotal).toFixed(2));
        allocated = Number((allocated + amount).toFixed(2));
        fixedAmountsByLineItemId[lineItem.id] = amount;
      });
    }

    const discountResponses = await Promise.all(
      parentLineItems
        .filter(lineItem => !isFixedAmount || (fixedAmountsByLineItemId[lineItem.id] ?? 0) > 0)
        .map(async lineItem => {
          const modifierLineItemIds = getModifierLineItemIds(lineItem?.id);
          const value = isFixedAmount
            ? fixedAmountsByLineItemId[lineItem.id]
            : customAmount
              ? Number(customAmount)
              : undefined;

          return await PostDiscountLine(
            {
              discount_id: discountId,
              cart_id: lineItem?.cart_id,
              cart_line_item_id: lineItem?.id,
              value,
              value_type: type,
              notes: discountNotes,
              modifier_line_item_ids: modifierLineItemIds?.length > 0 && isPercent ? modifierLineItemIds : undefined,
            },
            false,
          );
        }),
    );

    if (discountResponses?.some(res => res?.status !== StatusCode.OK)) {
      dispatch(showError(t("secure.facility.table_service.table_service_cart.table_service_cart.012")));
    }

    const cartRes = await GetCart({ id: cart?.id }, false);

    parentLineItems.forEach(lineItem => {
      void removeLineItemUpdating(lineItem?.id);
    });

    if (cartRes?.status !== StatusCode.OK || !(cartRes?.data?.length > 0)) {
      dispatch(showError(t("Error getting updated cart")));
      return;
    }

    const updatedCart = cartRes.data[0] as ICart;

    ReactDOM.unstable_batchedUpdates(() => {
      void dispatch(loadTableCart({ tableCart: updatedCart }, false));
      void updateActiveTable(updatedCart);
    });

    if (discountResponses?.every(res => res?.status === StatusCode.OK)) {
      dispatch(showSuccess(t("Discount applied successfully")));
    }
  }

  async function handleAddTip(tipAmount: number, tipAllocations?: Array<{ user_id: number; amount: number }>) {
    const res = await PutCart(
      {
        id: cart?.id,
        total_tip: tipAmount,
        ...(permissions?.orders_edit_tip_allocations
          ? { tip_allocations: tipAllocations ?? (tipAmount > 0 ? null : []) }
          : {}),
      },
      true,
    );

    if (res.status !== StatusCode.OK) {
      dispatch(showError(t("secure.facility.table_service.table_service_cart.table_service_cart.017")));
      return;
    }

    ReactDOM.unstable_batchedUpdates(() => {
      void dispatch(loadTableCart({ tableCart: res?.data as ICart }, false));
      void updateActiveTable(res?.data as ICart);
    });
  }

  async function handleAddNote() {
    if (!cart?.id) {
      return;
    }

    dispatch(enqueue());
    const cartRes = await PutCart({ id: cart.id, notes: viewNoteModal.addNote }, false);
    let order = cart?.order ? {...cart?.order} : undefined;
    // Order on cart exists, update the order's note as well
    if (cart?.order?.financial_status === "partially_paid") {
      const orderRes = await PutOrder({id: cart?.order_id, notes: viewNoteModal?.addNote}, false);
      if (orderRes?.status !== StatusCode.OK) {
        dispatch(dequeue());
        dispatch(showError(errorMessage(orderRes, t("Error adding note to order"))));
        return;
      }
      order = orderRes?.data;
    }

    dispatch(dequeue());

    if (cartRes.status !== StatusCode.OK) {
      dispatch(showError(t("Error adding note to order")));
      return;
    }

    ReactDOM.unstable_batchedUpdates(() => {
      void dispatch(loadTableCart({ tableCart: cartRes?.data as ICart }, false));
      void updateActiveTable({...cartRes?.data, order: order} as ICart);
    });

    closeViewNoteModal();
    dispatch(showSuccess(t("Note saved")));
  }

  async function handleToggleDisableAutoDiscounts() {
    if (!cart?.id) {
      return;
    }

    const cartRes = await PutCart(
      { id: cart.id, disable_auto_discounts: nextDisableAutoDiscountsValue(cart) },
      true,
    );

    if (cartRes.status !== StatusCode.OK) {
      dispatch(showError(t("Error updating cart")));
      return;
    }

    const updatedCart = cartRes.data as ICart;

    ReactDOM.unstable_batchedUpdates(() => {
      void dispatch(loadTableCart({ tableCart: updatedCart }, false));
      void updateActiveTable(updatedCart);
    });

    dispatch(
      showSuccess(isAutoDiscountsDisabled(updatedCart) ? t("Discounts disabled") : t("Discounts enabled")),
    );
  }

  async function handleAddServiceFee(serviceFeeId: number) {
    const params = {
      service_fee_id: serviceFeeId,
      facility_id: facilityStore?.facility?.id,
      cart_id: cartStore?.cart?.id,
    };

    const cartRes = await PostServiceFeeLineItem(params, true);

    ReactDOM.unstable_batchedUpdates(() => {
      void dispatch(loadTableCart({ tableCart: cartRes?.data as ICart }, false));
      void updateActiveTable(cartRes?.data as ICart);
    });
  }

  async function handleClearServiceFee() {
    const params = {
      // service_fee_id: selectedFee?.id,
      facility_id: facilityStore?.facility?.id,
      cart_id: cartStore?.cart?.id,
    };

    const cartRes = await DeleteServiceFeeLineItem(params, true);
    const cart = cartRes.data;

    dispatch({
      type: "cart.update",
      payload: {
        isLoaded: true,
        cart: cart,
      },
    });
  }

  function handlePrePaymentChecks() {
    if (cart) {
      if (cart?.status !== "complete" && cart?.status !== "void") {
        if (cart?.line_items?.length > 0) {
          const gift_cards: Array<TGiftCardParam> = [];
          const filteredGiftCards: Array<ICartLineItem> = cartStore?.cart.line_items?.filter(
            line_item => line_item?.product?.type === "Gift Card",
          );

          const filteredLeagueFees = cartStore?.cart.line_items?.filter(
            line_item => line_item?.product?.type === "League Registration Fee",
          );

          if (filteredLeagueFees?.length > 0 && !cartStore?.cart?.customer_id) {
            dispatch(showError(t("secure.facility.table_service.table_service_cart.table_service_cart.019")));
            return;
          }

          //Open gift cards modal if cart contains gift cards
          if (filteredGiftCards?.length > 0 || filteredLeagueFees?.length > 0) {
            if (filteredGiftCards.length > 0) {
              filteredGiftCards.forEach(line_item => {
                for (let i = 0; i < line_item?.quantity; i++) {
                  gift_cards.push({
                    product_id: line_item.product_id,
                    cart_line_item_id: line_item.id,
                    code: null,
                    pin: null,
                    random: true,
                    balance: line_item.price,
                    reload: 0,
                    gift_card_restrict_facility: line_item.product?.gift_card_restrict_facility,
                    gift_card_expiry_type: line_item.product?.gift_card_expiry_type,
                    gift_card_expiry_years: line_item.product?.gift_card_expiry_years,
                  });
                }
              });
              setPaymentState(prevState => ({ ...prevState, gift_cards, sellGiftCardsActive: true }));
            }
            //Check for league registration fees
            if (filteredLeagueFees?.length > 0) {
              setPaymentState(prevState => ({
                ...prevState,
                leagueFeesActive: true,
                leagueFeeProducts: filteredLeagueFees,
              }));
            }
          } else {
            //Go directly to payment modal if no gift cards / league fees in cart
            setPaymentState(prevState => ({
              ...prevState,
              gift_cards: null,
              paymentModalVisible: true,
              leagueFeeProducts: null,
              selectedLeagues: null,
            }));
          }
        } else {
          dispatch(showError(t("secure.facility.table_service.table_service_cart.table_service_cart.020"), 2000));
        }
      } else {
        dispatch(showError(t("secure.facility.table_service.table_service_cart.table_service_cart.021"), 2000));
      }
    } else {
      dispatch(showError(t("secure.facility.table_service.table_service_cart.table_service_cart.022")));
    }
  }

  function handleProcessPaymentCheck() {
    if (paymentState?.paymentOption?.payment_method === "gift_card") {
      setPaymentState(prevState => ({ ...prevState, giftCardModalVisible: true }));
    } else if (paymentState?.paymentOption?.payment_method === "account") {
      setPaymentState(prevState => ({ ...prevState, accountsVisible: true }));
    } else if (paymentState?.paymentOption?.payment_method === "credit_book") {
      updateCreditBook({ isOpen: true });
    } else if (paymentState?.paymentOption?.payment_method === "invoice") {
      updateInvoiceModal({ isOpen: true });
    } else if (
      paymentState?.paymentOption?.payment_method === "room_charge_rdp" ||
      paymentState?.paymentOption?.payment_method === "maestro"
    ) {
      setPaymentState(prevState => ({
        ...prevState,
        roomChargeSheetVisible: true,
        roomOccupantSearchQuery: "",
        roomOccupantsSearchResults: [],
        selectedOccupant: null,
      }));
    } else if (paymentState?.paymentOption?.payment_method === "deposit") {
      void updateCustomerDepositsModal({isOpen: true});
    } else {
      void handleProcessPayment();
    }
  }

  const handleProcessPayment = async (giftCardInfo?: IGiftCardRedeemState, deposit?: IBookingDeposit & { amountToApply?: string }) => {
    dispatch(enqueue());

    // If using an invoice as a payment method don't create order
    if (paymentState?.paymentOption?.payment_method === "invoice") {
      if (!invoiceModal.selectedInvoice) {
        dispatch(dequeue());
        dispatch(showError("No invoice selected"));
        return;
      }

      const migrateRes = await PostMigrateCart({ cart_id: cart.id, invoice_id: invoiceModal.selectedInvoice.id }, true);

      if (migrateRes.status !== StatusCode.OK) {
        dispatch(dequeue());
        dispatch(showError("Error migrating cart to invoice"));
        return;
      }

      await handleClearCart(true);
      updateInvoiceModal({ selectedInvoice: null });
      dispatch(dequeue());
      dispatch(showSuccess("Cart migrated to invoice successfully"));
      return;
    }

    setPaymentState(prevState => ({ ...prevState, paymentInProgress: true }));
    const cartTotal = Number(cartStore?.cart?.total_price?.toFixed(2));
    try {
      const cart_id = cartStore?.cart?.id;

      // Checking out produces a new order

      let checkoutRes: { status: any; data: any };
      const register = JSON.parse(localStorage.getItem("register"));
      const registerId = register?.id ? register?.id : undefined;

      let paymentOrder: IOrder;
      if (!order || order?.financial_status === "unpaid" || order?.financial_status === "cancelled") {
        //Void the order if it is unpaid. This situation could happen if the user tries to make a reader payment then decides to cancel the transaction.
        if (order?.financial_status === "unpaid") {
          const voidRes = await PutVoidOrder(
            {
              order_id: order?.id,
              notes: t("secure.facility.table_service.table_service_cart.table_service_cart.023"),
              financial_status: "cancelled",
            },
            false,
          );
          if (voidRes?.status !== StatusCode.OK) {
            dispatch(showError(t("Error voiding previous order")));
          }
        }
        // Create a new order if order does not exist in state
        checkoutRes = await PostCheckout({ cart_id, register_id: registerId }, false);
        if (checkoutRes?.status !== StatusCode.OK) {
          dispatch(showError(t("secure.facility.table_service.table_service_cart.table_service_cart.024")));
          return;
        }
        paymentOrder = checkoutRes?.data?.order;
        setTableState(prevState => ({ ...prevState, order: checkoutRes?.data?.order }));
      } else {
        //Continue order
        paymentOrder = order;
      }

      const finalAmount = Number(paymentState.paymentAmount);

      //Check to see if amount is acceptable
      if (Number.isNaN(finalAmount)) {
        dispatch(dequeue());
        dispatch(
          showError(
            `'${paymentState.paymentAmount}' ${t(
              "secure.facility.table_service.table_service_cart.table_service_cart.025",
            )}`,
          ),
        );
        setPaymentState(prevState => ({ ...prevState, paymentInProgress: false }));
        return;
      }

      if (
        (finalAmount > cartTotal && paymentState.paymentOption?.payment_method !== "cash") ||
        (finalAmount > order?.balance && paymentState.paymentOption?.payment_method !== "cash") ||
        finalAmount < 0
      ) {
        dispatch(dequeue());
        dispatch(
          showError(
            `'${paymentState.paymentAmount}'${t(
              "secure.facility.table_service.table_service_cart.table_service_cart.026",
            )}`,
          ),
        );
        setPaymentState(prevState => ({ ...prevState, paymentInProgress: false }));
        return;
      }

      if ((order || paymentOrder) && !paymentState.paymentInProgress) {
        const order_id = paymentOrder ? paymentOrder?.id : order?.id;

        if (paymentState.paymentOption?.payment_method === "manual_card") {
          const transactionRes = await PostTransaction(
            {
              kind: "sale",
              amount: finalAmount,
              order_id: order_id,
              payment_option_id: paymentState.paymentOption?.id,
            },
            false,
          );

          if (transactionRes.status === StatusCode.OK) {
            setManualStripeState(prevState => ({
              ...prevState,
              transaction: transactionRes.data,
              clientSecret: transactionRes.data.client_secret,
              visible: true,
            }));
          } else {
            dispatch(showError(t("secure.facility.table_service.table_service_cart.table_service_cart.027")));
            setPaymentState(prevState => ({ ...prevState, paymentInProgress: false }));
            dispatch(dequeue());
            return;
          }
          // Using terminal - display modal
        } else if (paymentState.paymentOption?.payment_method === "card") {
          if (facilityStore.facility.terminal_integration === "server") {
            setPaymentState(prevState => ({ ...prevState, paymentInProgress: true }));
            // If cart already has a tip, skip tipping
            await processPayment(
              order_id,
              paymentState.paymentOption,
              finalAmount,
              undefined,
              undefined,
              undefined,
              undefined,
              undefined,
              Number(cart?.total_tip) > 0 ? true : false,
            );
            setPaymentState(prevState => ({ ...prevState, paymentInProgress: false }));
          } else {
            dispatch(dequeue());
            setStripePaymentState(prevState => ({
              ...prevState,
              sheetVisible: true,
              onCancel: undefined,
              okText: t("secure.facility.table_service.table_service_cart.table_service_cart.028"),
              processing: true,
              onOk: async () => {
                setStripePaymentState(prevState => ({
                  ...prevState,
                  sheetVisible: false,
                  onCancel: undefined,
                  okText: undefined,
                  processing: false,
                  onOk: () => { },
                  titleText: "",
                  success: false,
                  message: "",
                }));
                await clearReaderDisplay();
              },
              titleText: t("secure.facility.table_service.table_service_cart.table_service_cart.003"),
              message: t("secure.facility.table_service.table_service_cart.table_service_cart.029"),
            }));

            await stripeProcessPayment(
              order_id,
              finalAmount,
              paymentState.paymentOption,
              handleStripeSuccess,
              handleStripeError,
            );
            dispatch(enqueue());
          }
        } else if (paymentState.paymentOption?.payment_method === "gift_card") {
          const transactionRes = await PostTransaction(
            {
              kind: "sale",
              amount: finalAmount,
              order_id: order_id,
              payment_option_id: paymentState.paymentOption?.id,
              gift_card_code: giftCardInfo.giftCardCode,
              gift_card_pin: giftCardInfo.giftCardPin,
            },
            false,
          );

          if (transactionRes.status === StatusCode.OK) {
            setPaymentState(prevState => ({
              ...prevState,
              giftCardCode: "",
              giftCardPin: "",
              giftCardModalVisible: false,
            }));

            // display success notification
            dispatch(showSuccess(t("secure.facility.table_service.table_service_cart.table_service_cart.030")));

            await updateOrder(transactionRes.data.order_id, true);
          } else {
            dispatch(
              showError(
                transactionRes?.status === StatusCode.BAD_REQUEST && typeof transactionRes?.data === "string"
                  ? transactionRes?.data
                  : t("secure.facility.table_service.table_service_cart.table_service_cart.031"),
              ),
            );
            setPaymentState(prevState => ({ ...prevState, paymentInProgress: false }));
            dispatch(dequeue());
            return;
          }
        } else if (paymentState.paymentOption?.payment_method === "account") {
          const transactionRes = await PostTransaction(
            {
              kind: "sale",
              amount: finalAmount,
              order_id: order_id,
              payment_option_id: paymentState.paymentOption.id,
              account_id: paymentState.selectedAccount.id,
            },
            false,
          );

          if (transactionRes?.status !== StatusCode.OK) {
            dispatch(showError(t("secure.facility.table_service.table_service_cart.table_service_cart.032")));
            setPaymentState(prevState => ({ ...prevState, paymentInProgress: false }));
            dispatch(dequeue());
            return;
          }

          // display success notification
          dispatch(showSuccess(t("secure.facility.table_service.table_service_cart.table_service_cart.033")));

          // Update order and check if there is a remaining balance
          await updateOrder(transactionRes.data.order_id, true);
        } else if (paymentState.paymentOption?.payment_method === "credit_book") {
          const transactionRes = await PostTransaction(
            {
              kind: "sale",
              amount: finalAmount,
              order_id: order_id,
              payment_option_id: paymentState.paymentOption.id,
              credit_book_id: modalCreditBook.selectedCreditBook.id,
            },
            false,
          );

          if (transactionRes?.status !== StatusCode.OK) {
            setPaymentState(prevState => ({ ...prevState, paymentInProgress: false }));
            closeCreditBook();
            dispatch(
              showError(
                typeof transactionRes?.data === "string"
                  ? transactionRes.data
                  : t("secure.facility.table_service.table_service_cart.table_service_cart.034"),
              ),
            );
            dispatch(dequeue());
            return;
          }

          // display success notification
          dispatch(showSuccess(t("secure.facility.table_service.table_service_cart.table_service_cart.033")));

          // Update order and check if there is a remaining balance
          await updateOrder(transactionRes.data.order_id, true);
        } else if (
          paymentState.paymentOption?.payment_method === "room_charge_rdp" ||
          paymentState.paymentOption?.payment_method === "maestro"
        ) {
          const transactionRes = await PostTransaction(
            {
              kind: "sale",
              amount: finalAmount,
              order_id: order_id,
              payment_option_id: paymentState.paymentOption?.id,
              guest_name: paymentState?.selectedOccupant?.guest_name,
              room_number: paymentState.paymentOption?.payment_method === "room_charge_rdp" ? paymentState.selectedOccupant?.room_number : paymentState.roomOccupantSearchQuery,
            },
            false,
          );

          if (transactionRes.status !== StatusCode.OK) {
            dispatch(showError(t("secure.facility.table_service.table_service_cart.table_service_cart.034")));
            dispatch(dequeue());
            return;
          } else {
            dispatch(showSuccess(t("secure.facility.table_service.table_service_cart.table_service_cart.033")));

            // Update order and check if there is a remaining balance
            await updateOrder(transactionRes.data.order_id, true);

            setPaymentState(prevState => ({
              ...prevState,
              roomChargeSheetVisible: false,
              roomOccupantSearchQuery: "",
              roomOccupantsSearchResults: [],
              selectedOccupant: null,
            }));
          }
        } else if (paymentState?.paymentOption?.payment_method === "deposit") {
          const transactionRes = await PostTransaction(
            {
              kind: "sale",
              amount: Math.min(Number(deposit?.amountToApply), finalAmount),
              order_id: order_id,
              payment_option_id: paymentState?.paymentOption?.id,
              deposit_id: deposit?.id,
            },
            false,
          );

          if (transactionRes?.status !== StatusCode.OK) {
            setPaymentState(prevState => ({ ...prevState, paymentInProgress: false }));
            dispatch(dequeue());
            dispatch(showError(t(typeof transactionRes?.data === "string" ? transactionRes?.data : "Error processing transaction")));
            return;
          }

          dispatch(showSuccess(t("secure.facility.table_service.table_service_cart.table_service_cart.033")));

          await updateOrder(transactionRes.data.order_id, true);
        } else {
          let exactChangeDue: number;
          const roundCashChange = facilityStore.teeSheetSettings?.register_cash_round_change === true;
          //Display change due for cash payments
          if (paymentState.paymentOption?.payment_method === "cash") {
            if (paymentOrder?.balance && Number(paymentState.paymentAmount) > paymentOrder?.balance) {
              exactChangeDue = Number(paymentState.paymentAmount) - paymentOrder?.balance;
              setPaymentState(prevState => ({
                ...prevState,
                changeDue: getDisplayCashChangeDue(exactChangeDue, roundCashChange),
                changeDueVisible: true,
              }));
            } else if (Number(paymentState.paymentAmount) > cartTotal) {
              exactChangeDue = Number(paymentState.paymentAmount) - cartTotal;
              setPaymentState(prevState => ({
                ...prevState,
                changeDue: getDisplayCashChangeDue(exactChangeDue, roundCashChange),
                changeDueVisible: true,
              }));
            }
          }
          const transactionRes = await PostTransaction(
            {
              kind: "sale",
              amount: exactChangeDue ? finalAmount - exactChangeDue : finalAmount,
              order_id: order_id,
              payment_option_id: paymentState.paymentOption?.id,
            },
            false,
          );

          if (transactionRes.status !== StatusCode.OK) {
            dispatch(showError(t("secure.facility.table_service.table_service_cart.table_service_cart.034")));
            setPaymentState(prevState => ({ ...prevState, paymentInProgress: false }));
            dispatch(dequeue());
            return;
          }

          // display success notification
          dispatch(showSuccess(t("secure.facility.table_service.table_service_cart.table_service_cart.033")));

          // Update order and check if there is a remaining balance
          await updateOrder(transactionRes.data.order_id, true);
        }
      }
    } catch (e) {
      console.log("err:", e);
    }
    setPaymentState(prevState => ({ ...prevState, paymentInProgress: false }));
    dispatch(dequeue());
  };

  async function updateOrder(order_id: number, clearCart: boolean) {
    if (order_id) {
      //Update order
      const orderRes = await GetOrder({ id: order_id, extended: true }, true);
      if (orderRes.status !== StatusCode.OK) {
        dispatch(showError(t("secure.facility.table_service.table_service_cart.table_service_cart.035")));
        return;
      }
      setManualProcessing(false);

      const updatedOrder = orderRes.data[0];
      if (updatedOrder.balance <= 0 || updatedOrder.financial_status === "paid") {
        if (clearCart) {
          const previousCartCustomerTypeId = cart?.customer?.cart_customer_type_id ?? null;
          const completedOrder = await completeOrder(order_id);

          if (terminalStore?.reader) {
            void clearReaderDisplay();
          }

          ReactDOM.unstable_batchedUpdates(() => {
            setTableState(prevState => ({
              ...prevState,
              order: {
                ...updatedOrder,
                loyalty_program_transactions: completedOrder?.loyalty_program_transactions
                  ? completedOrder?.loyalty_program_transactions
                  : [],
              },
            }));
            setPaymentState(prevState => ({
              ...prevState,
              paymentModalVisible: false,
              giftCardModalVisible: false,
              selectedAccount: undefined,
              paymentOption: null,
            }));
          });

          //Refresh inventory data
          if (selectedFolder && updatedOrder) {
            void loadInventoryLevels(selectedFolder, updatedOrder as IOrder);
          }

          //Order completed, display order complete modal
          void updateOrderComplete({ isOpen: true });

          if (completedOrder) {
            await promptFutureBookingPricingAfterMembershipOrder(
              {
                customer_id: completedOrder.customer_id ?? updatedOrder.customer_id,
                line_items: updatedOrder.line_items,
                previousCartCustomerTypeId,
              },
              openFutureBookingPricingModalIfNeeded,
            );
          }
        }
      } else {
        if (activeTable) {
          void reloadTable();
        }
        // Still need to process another payment for this order
        ReactDOM.unstable_batchedUpdates(() => {
          setTableState(prevState => ({ ...prevState, order: updatedOrder }));
          setPaymentState(prevState => ({
            ...prevState,
            paymentAmount: updatedOrder?.balance.toFixed(2),
            giftCardModalVisible: false,
          }));
        });
      }
    }
  }

  async function reloadTable() {
    const tablesRes = await GetTable({ id: activeTable?.id, carts: true, orders: true }, false);

    if (tablesRes.status !== StatusCode.OK) {
      dispatch(showError(t("secure.facility.table_service.table_service_cart.table_service_cart.036")));
      return;
    }

    const currentCart = tablesRes?.data[0]?.carts?.find(searchedCart => searchedCart?.token === cart?.token);
    if (currentCart) {
      void dispatch(loadTableCart({ tableCart: currentCart }, false));
    }
    void dispatch(setActiveTable(tablesRes?.data[0]));
  }

  async function completeOrder(order_id: number) {
    const register = JSON.parse(localStorage.getItem("register"));
    const registerId = register?.id;
    dispatch(enqueue());
    const completeRes = await PutOrderComplete(
      {
        order_id,
        gift_cards: serializeGiftCardsForSale(paymentState.gift_cards),
        register_id: registerId,
        league_ids: paymentState.selectedLeagues,
      },
      false,
    );

    if (completeRes.status !== StatusCode.OK) {
      dispatch(showError(t("secure.facility.table_service.table_service_cart.table_service_cart.037")));
      return;
    }
    if (activeTable) {
      await reloadTable();
    }

    dispatch(dequeue());
    dispatch(showSuccess(t("secure.facility.table_service.table_service_cart.table_service_cart.038")));
    setPaymentState(prevState => ({ ...prevState, gift_cards: null, selectedLeagues: null }));

    if (cart?.customer) {
      void getLoyaltyCustomer(cart?.customer_id);
    }

    return completeRes?.data as IOrder;
  }

  function closeOrderCompletePopup() {
    ReactDOM.unstable_batchedUpdates(() => {
      setTableState(prevState => ({ ...prevState, order: undefined }));
      void closeOrderComplete();
    });
  }

  function handlePaymentOptionChange(paymentOption: Record<string, any>) {
    if (paymentOption !== undefined) {
      setPaymentState(prevState => ({
        ...prevState,
        paymentOption: paymentOption,
      }));
    }
  }

  function closePaymentSheet() {
    setPaymentState(prevState => ({
      ...prevState,
      paymentModalVisible: false,
      paymentAmount: order?.balance ? order?.balance?.toFixed(2) : cart?.total_price.toFixed(2),
      paymentOption: null,
    }));
  }

  function cancelGiftCardsAndLeagues() {
    setPaymentState(prevState => ({
      ...prevState,
      sellGiftCardsActive: false,
      gift_cards: null,
      leagueFeesActive: false,
      leagueFeeProducts: null,
      selectedLeagues: null,
    }));
  }

  async function validateGiftCardCode(code: string, reload: number) {
    const validateRes = await GetGiftCardValidate({ code, reload }, true);
    if (validateRes.status !== StatusCode.OK) {
      dispatch(
        showError(
          reload
            ? t("secure.facility.table_service.table_service_cart.table_service_cart.039")
            : t("secure.facility.table_service.table_service_cart.table_service_cart.040"),
        ),
      );
      return false;
    }
    return true;
  }

  async function handleAddSellGiftCards() {
    let validateRes = true;
    //Validate gift card codes
    for (const gift_card of paymentState.gift_cards) {
      if (!gift_card.random) {
        validateRes = await validateGiftCardCode(gift_card.code, gift_card.reload);
      }
      if (validateRes === false) {
        return;
      }
    }

    if (validateRes) {
      const moveToPaymentMethods = checkToContinuePayment("gift_card");
      setPaymentState(prevState => ({
        ...prevState,
        sellGiftCardsActive: false,
        paymentModalVisible: moveToPaymentMethods,
      }));
      dispatch(showSuccess(t("secure.facility.table_service.table_service_cart.table_service_cart.041")));
    }
  }

  function setSelectedLeagues(leagues: Array<number>) {
    const moveToPaymentMethods = checkToContinuePayment("leagues");
    setPaymentState(prevState => ({
      ...prevState,
      selectedLeagues: leagues,
      leagueFeesActive: false,
      leagueFeeProducts: null,
      paymentModalVisible: moveToPaymentMethods,
    }));
  }

  function checkToContinuePayment(type: "gift_card" | "leagues") {
    switch (type) {
      case "gift_card":
        if (!paymentState.selectedLeagues && paymentState.leagueFeesActive) {
          return false;
        }
        return true;
      case "leagues":
        if (paymentState.sellGiftCardsActive) {
          return false;
        }
        return true;
      default:
        return true;
    }
  }

  function handleCardSectionChange(
    e: StripeCardNumberElementChangeEvent | StripeCardExpiryElementChangeEvent | StripeCardCvcElementChangeEvent,
  ) {
    setManualStripeState(prevState => ({
      ...prevState,
      elementComplete: { ...prevState.elementComplete, [e.elementType]: e.complete },
    }));
  }

  function handleManualProcessing() {
    if (manualProcessing === true) {
      setManualProcessing(false);
    } else {
      setManualProcessing(true);
    }
  }

  function handleOpenCloseTableModal() {
    const seats = [...activeTable.carts];
    const partiallyPaidSeats = seats?.some(seatCart => seatOrderHasCollectedPayments(getSeatOrder(seatCart)));
    updateCloseTable({
      isOpen: true,
      seatsOpen: seats?.filter(cart => cart?.status === "open")?.every(cart => cart?.line_items?.length === 0),
      partiallyPaidSeats,
      voidSeats: seats?.some(cart => cart?.line_items?.length > 0 && cart?.status === "open"),
    });
  }

  async function handleCloseTable(options?: { skipPartialPaymentCheck?: boolean; ordersAlreadyVoided?: boolean }) {
    // Partially paid seats: refund flow is handled by the close-table popup OK action
    if (closeTable?.partiallyPaidSeats && !options?.skipPartialPaymentCheck) {
      return;
    }
    //Void open seats that contain line items
    if (closeTable?.voidSeats && permissions?.orders_void) {
      const seatsToVoid = [...cartStore.activeTable.carts]
        ?.filter(cart => cart?.status === "open" && cart?.line_items?.length > 0)
        ?.map(cart => cart?.id);
      if (seatsToVoid?.length > 0) {
        void updateCloseTable({
          loadingMessage: t("secure.facility.table_service.table_service_cart.table_service_cart.043"),
        });

        // Void associated orders first (unpaid → cancelled, otherwise → voided)
        for (const seatCart of cartStore.activeTable.carts.filter(
          cart => cart?.status === "open" && cart?.line_items?.length > 0,
        )) {
          const seatOrder = getSeatOrder(seatCart);
          if (
            !options?.ordersAlreadyVoided &&
            seatOrder &&
            seatOrder.financial_status !== "voided" &&
            seatOrder.financial_status !== "cancelled"
          ) {
            const voided = await voidAssociatedOrder(seatOrder, closeTable?.cancel_reason || "Table closed");
            if (!voided) {
              void updateCloseTable({ loadingMessage: "" });
              return;
            }
          }
        }

        const voidRes = await PutVoidCarts({ cart_ids: seatsToVoid, cancel_reason: closeTable?.cancel_reason }, false);
        if (voidRes?.status !== StatusCode.OK) {
          dispatch(showError(t("secure.facility.table_service.table_service_cart.table_service_cart.044")));
          void updateCloseTable({ loadingMessage: "" });
          return;
        }
      }
    }
    //Close open seats with no line items
    const openSeats = [...cartStore.activeTable.carts]
      ?.filter(cart => cart?.status === "open" && cart?.line_items?.length === 0)
      ?.map(cart => cart?.id);
    if (openSeats?.length > 0) {
      void updateCloseTable({
        loadingMessage: t("secure.facility.table_service.table_service_cart.table_service_cart.045"),
      });
      const responses = await Promise.all(openSeats?.map(cartId => PutCart({ id: cartId, status: "closed" }, false)));
      if (responses?.some(res => res?.status !== StatusCode.OK)) {
        dispatch(showError(t("secure.facility.table_service.table_service_cart.table_service_cart.046")));
        void updateCloseTable({ loadingMessage: "" });
        return;
      }
    }

    void updateCloseTable({
      loadingMessage: t("secure.facility.table_service.table_service_cart.table_service_cart.047"),
    });
    //Close table
    const closeTableRes = await PutCloseTable({ table_id: activeTable?.id }, false);
    if (closeTableRes.status !== StatusCode.OK) {
      dispatch(showError(t("secure.facility.table_service.table_service_cart.table_service_cart.048")));
      void updateCloseTable({ loadingMessage: "" });
      return;
    }
    void cancelCloseTable();

    //Check register to auto log out
    const register = JSON.parse(localStorage.getItem("register"));
    if (register && register?.auto_log_out === true) {
      localStorage.setItem("switch_user_after_transaction", "true");
    }

    dispatch(showSuccess(t("secure.facility.table_service.table_service_cart.table_service_cart.049")));
    void navigateToTableSelection();
  }

  async function handleSendChit(lineItemIds: number[]) {
    setTableState(prevState => ({
      ...prevState,
      cartLoadingMessage: t("secure.facility.table_service.table_service_cart.table_service_cart.050"),
    }));
    void cancelSendChits();

    const res = await PostKitchenChit({ table_id: activeTable?.id, line_item_ids: lineItemIds }, false);
    if (res.status !== StatusCode.OK) {
      setTableState(prevState => ({ ...prevState, cartLoadingMessage: "" }));
      dispatch(showError(t("secure.facility.table_service.table_service_cart.table_service_cart.051")));
      return;
    }

    const chits = res?.data;
    let chitCount = 0;
    const tasks = [];

    for (const chit of chits) {
      chit.chit_number = ++chitCount;
      chit.total_chits = chits.length;

      tasks.push(printDesktopKitchenChit(chit as IChit, t));
    }

    Promise.all(tasks)
      .then(() => dispatch(showSuccess(t("secure.facility.table_service.table_service_cart.table_service_cart.052"))))
      .catch(error => dispatch(showError(error as string)));

    // refresh table and cart
    await reloadTable();

    ReactDOM.unstable_batchedUpdates(() => {
      setTableState(prevState => ({ ...prevState, cartLoadingMessage: "" }));
      setForceRefreshChits(true);
    });
  }

  async function handlePrintReceipt(printChitInfo: { addedLineItems: Array<number> }) {
    const receiptRes = await GetTableReceipt(
      { table_id: activeTable?.id, line_item_ids: printChitInfo?.addedLineItems },
      true,
    );
    if (receiptRes.status !== StatusCode.OK) {
      dispatch(showError(t("secure.facility.table_service.table_service_cart.table_service_cart.053")));
      return;
    }
    printDesktopReceipt(facilityStore.facility?.id, receiptRes.data.toString());
    void cancelPrintChits();
  }

  async function sendFireChit() {
    const fireChitRes = await FireKitchenChit({ table_id: activeTable?.id }, true);

    if (fireChitRes.status !== StatusCode.OK) {
      dispatch(showError(t("secure.facility.table_service.table_service_cart.table_service_cart.054")));
      return;
    }

    printChits(fireChitRes.data as Array<IChit>);

    dispatch(showSuccess(t("secure.facility.table_service.table_service_cart.table_service_cart.055")));
  }

  function getSeatOrder(seatCart?: ICart | null): IOrder | undefined {
    if (seatCart?.order) {
      return seatCart.order;
    }
    if (order && (!seatCart || seatCart.id === cart?.id)) {
      return order;
    }
    return undefined;
  }

  function seatOrderHasCollectedPayments(seatOrder?: IOrder | null): boolean {
    return orderHasCollectedPayments(
      seatOrder?.financial_status,
      seatOrder?.transactions,
      seatOrder?.balance,
      seatOrder?.total_price,
    );
  }

  function handleVoidSeatClick() {
    const seatOrder = getSeatOrder(cart);
    if (seatOrderHasCollectedPayments(seatOrder)) {
      setShowRefundBeforeVoidSeat(true);
      return;
    }
    updateVoidSeat({ isOpen: true });
  }

  async function voidAssociatedOrder(seatOrder: IOrder | undefined, voidNote: string): Promise<boolean> {
    if (!seatOrder?.id) {
      return true;
    }
    if (seatOrder.financial_status === "voided" || seatOrder.financial_status === "cancelled") {
      return true;
    }

    const isUnpaid = seatOrder.financial_status === "unpaid" && !seatOrderHasCollectedPayments(seatOrder);
    const voidRes = await PutVoidOrder(
      {
        order_id: seatOrder.id,
        notes: "Seat voided",
        financial_status: isUnpaid ? "cancelled" : "voided",
        void_note: voidNote,
      },
      true,
    );

    if (voidRes.status !== StatusCode.OK) {
      const message =
        (typeof voidRes.message === "string" && voidRes.message) ||
        (typeof voidRes.data === "string" && voidRes.data) ||
        voidRes.data?.message ||
        "";
      if (/already (voided|cancelled)/i.test(message as string)) {
        return true;
      }
      dispatch(showError(message as string || t("Error voiding order")));
      return false;
    }
    return true;
  }

  async function handleRefundBeforeVoidSeat() {
    const seatOrder = getSeatOrder(cart);
    if (!seatOrder?.id || refundingPayments) {
      return;
    }

    setRefundingPayments(true);
    const refundResult = await refundOrderPayments({
      orderId: seatOrder.id,
      transactions: seatOrder.transactions,
      processInteracRefund: processRefund,
      hasReader: Boolean(terminalStore?.reader),
      note: "Refunded payments before voiding seat",
    });

    if (!refundResult.ok) {
      setRefundingPayments(false);
      dispatch(showError(refundResult.message || t("Failed to refund payments")));
      return;
    }

    dispatch(showSuccess(t("Payments refunded")));
    const voided = await voidAssociatedOrder(seatOrder, "Voided after payment refund");
    setRefundingPayments(false);
    setShowRefundBeforeVoidSeat(false);

    if (!voided) {
      return;
    }

    // Proceed with cart void using a default reason after refund
    await handleSeatCartVoid("Refunded payments on void", true);
  }

  function handleContinueVoidSeatWithoutRefund() {
    setShowRefundBeforeVoidSeat(false);
    updateVoidSeat({ isOpen: true });
  }

  function getPartiallyPaidSeats(): ICart[] {
    return (activeTable?.carts ?? []).filter(seatCart =>
      seatOrderHasCollectedPayments(getSeatOrder(seatCart)),
    );
  }

  async function handleRefundBeforeCloseTable() {
    if (refundingPayments) {
      return;
    }

    const seats = getPartiallyPaidSeats();
    if (!seats.length) {
      return;
    }

    setRefundingPayments(true);
    for (const seatCart of seats) {
      const seatOrder = getSeatOrder(seatCart);
      if (!seatOrder?.id) {
        continue;
      }

      const refundResult = await refundOrderPayments({
        orderId: seatOrder.id,
        transactions: seatOrder.transactions,
        processInteracRefund: processRefund,
        hasReader: Boolean(terminalStore?.reader),
        note: "Refunded payments before closing table",
      });

      if (!refundResult.ok) {
        setRefundingPayments(false);
        dispatch(showError(refundResult.message || t("Failed to refund payments")));
        return;
      }

      const voided = await voidAssociatedOrder(seatOrder, "Voided after payment refund");
      if (!voided) {
        setRefundingPayments(false);
        return;
      }
    }

    dispatch(showSuccess(t("Payments refunded")));
    setRefundingPayments(false);
    // Refresh close-table flags then continue close
    updateCloseTable({
      partiallyPaidSeats: false,
      voidSeats: (activeTable?.carts ?? []).some(
        seatCart => seatCart?.line_items?.length > 0 && seatCart?.status === "open",
      ),
    });
    await handleCloseTable({ skipPartialPaymentCheck: true, ordersAlreadyVoided: true });
  }

  async function handleSeatCartVoid(cancelReasonOverride?: string, orderAlreadyVoided = false) {
    if (cartStore?.cart) {
      ReactDOM.unstable_batchedUpdates(() => {
        void closeVoidSeat();
        setTableState(prevState => ({
          ...prevState,
          cartLoadingMessage: t("secure.facility.table_service.table_service_cart.table_service_cart.056"),
        }));
      });

      const seatOrder = getSeatOrder(cart);
      if (!orderAlreadyVoided) {
        const voided = await voidAssociatedOrder(
          seatOrder,
          cancelReasonOverride || voidSeat.cancel_reason || "Seat voided",
        );
        if (!voided) {
          setTableState(prevState => ({ ...prevState, cartLoadingMessage: "" }));
          return;
        }
      }

      const voidRes = await PutVoidCarts(
        {
          cart_ids: [cart?.id],
          cancel_reason: cancelReasonOverride || voidSeat.cancel_reason,
        },
        false,
      );
      if (voidRes.status !== StatusCode.OK) {
        dispatch(showError(t("secure.facility.table_service.table_service_cart.table_service_cart.057")));
        setTableState(prevState => ({ ...prevState, cartLoadingMessage: "" }));
        return;
      }
      let voidedCart = [...voidRes.data]?.find(voidedCart => voidedCart?.id === cart?.id);
      if (!voidedCart) {
        voidedCart = voidRes?.data[0] ? voidRes?.data[0] : activeTable?.carts[0];
      }
      ReactDOM.unstable_batchedUpdates(() => {
        void dispatch(loadTableCart({ tableCart: voidedCart as ICart }, false));
        void updateActiveTable(voidedCart as ICart);
        setTableState(prevState => ({ ...prevState, cartLoadingMessage: "", order: undefined }));
      });

      dispatch(showSuccess(t("secure.facility.table_service.table_service_cart.table_service_cart.058")));
    } else {
      dispatch(showError(t("secure.facility.table_service.table_service_cart.table_service_cart.059")));
    }
  }

  async function handleSeatCartClose() {
    if (cartStore?.cart) {
      ReactDOM.unstable_batchedUpdates(() => {
        void closeCloseSeat();
        setTableState(prevState => ({
          ...prevState,
          cartLoadingMessage: t("secure.facility.table_service.table_service_cart.table_service_cart.060"),
        }));
      });
      const closeRes = await PutCart({ id: cartStore?.cart?.id, status: "closed" }, false);
      if (closeRes?.status !== StatusCode.OK) {
        dispatch(showError(t("secure.facility.table_service.table_service_cart.table_service_cart.061")));
        setTableState(prevState => ({ ...prevState, cartLoadingMessage: "" }));
        return;
      }
      setTableState(prevState => ({ ...prevState, cartLoadingMessage: "" }));
      void handleRemoveSeat();
      dispatch(showSuccess(t("secure.facility.table_service.table_service_cart.table_service_cart.062")));
    } else {
      dispatch(showError(t("secure.facility.table_service.table_service_cart.table_service_cart.063")));
    }
  }

  function handleRemoveSeat() {
    const currentCartId = cartStore.cart.id;
    const tableCarts = [...cartStore.activeTable.carts]?.filter(cart => cart?.id !== currentCartId);
    const table = { ...cartStore.activeTable, carts: tableCarts };
    // If there are still seats available, set the first seat of the table in state
    if (tableCarts?.length > 0) {
      const firstCart = tableCarts[0];
      ReactDOM.unstable_batchedUpdates(() => {
        void dispatch(loadTableCart({ tableCart: firstCart }, false));
        if (firstCart?.order) {
          setTableState(prevState => ({ ...prevState, order: firstCart?.order, cartLoadingMessage: "" }));
        }
      });
    } else {
      // No carts left, set active cart to null
      ReactDOM.unstable_batchedUpdates(() => {
        setTableState(prevState => ({ ...prevState, order: undefined, cartLoadingMessage: "" }));
        void dispatch(loadTableCart({ tableCart: null }, false));
      });
    }
    void dispatch(setActiveTable(table));
  }

  async function handleClearCart(clearWithInvoice?: boolean) {
    ReactDOM.unstable_batchedUpdates(() => {
      void closeClearSeat();
      setTableState(prevState => ({
        ...prevState,
        cartLoadingMessage: t("secure.facility.table_service.table_service_cart.table_service_cart.064"),
      }));
    });
    const clearRes = await PutClearCart(
      {
        cart_id: cart?.id,
      },
      false,
    );

    if (terminalStore?.reader) {
      void clearReaderDisplay();
    }

    if (clearRes.status !== StatusCode.OK) {
      dispatch(showError(t("secure.facility.table_service.table_service_cart.table_service_cart.065")));
      setTableState(prevState => ({ ...prevState, cartLoadingMessage: "" }));
      return;
    }

    ReactDOM.unstable_batchedUpdates(() => {
      void dispatch(loadTableCart({ tableCart: clearRes?.data as ICart }, false));
      void updateActiveTable(clearRes?.data as ICart);
      setTableState(prevState => ({ ...prevState, cartLoadingMessage: "" }));
    });

    if (!clearWithInvoice) {
      dispatch(showSuccess("Successfully cleared seat"));
    }
    dispatch(showSuccess(t("secure.facility.table_service.table_service_cart.table_service_cart.066")));
  }

  async function handleSeatMerge(mergeSeatInfo: IMergeSeatsState) {
    ReactDOM.unstable_batchedUpdates(() => {
      void closeMergeSeats();
      setTableState(prevState => ({
        ...prevState,
        cartLoadingMessage: t("secure.facility.table_service.table_service_cart.table_service_cart.067"),
      }));
    });
    const mergeRes = await PostMerge(
      { cart_ids: mergeSeatInfo.selectedMergeSeatIds, table_id: activeTable?.id },
      false,
    );
    if (mergeRes.status !== StatusCode.OK) {
      dispatch(showError(t("secure.facility.table_service.table_service_cart.table_service_cart.068")));
      setTableState(prevState => ({ ...prevState, cartLoadingMessage: "" }));
      return;
    }
    dispatch(showSuccess(t("secure.facility.table_service.table_service_cart.table_service_cart.069")));

    //Refresh table
    await dispatch(loadActiveTableNew(cartStore?.activeTable?.id, false));
    ReactDOM.unstable_batchedUpdates(() => {
      void dispatch(loadTableCart({ tableCart: mergeRes?.data }, false));
      setTableState(prevState => ({ ...prevState, cartLoadingMessage: "" }));
    });
  }

  function handleOpenCartDetailsSheet() {
    if (cart?.status === "open" && cart?.order?.financial_status !== "partially_paid") {
      void updateSeatDetails({ isOpen: true, customer: cart?.customer, description: cart?.description ?? "" });
    }
  }

  async function handleUpdateCartDetails(cartDetails: { cartDescription: string; selectedCustomer: ICustomer }) {
    if (cart) {
      ReactDOM.unstable_batchedUpdates(() => {
        void closeSeatDetails();
        setTableState(prevState => ({
          ...prevState,
          cartLoadingMessage: t("secure.facility.table_service.table_service_cart.table_service_cart.070"),
        }));
      });

      const previousCustomerId = seatDetails?.customer?.id ?? null;
      const nextCustomerId =
        cartDetails?.selectedCustomer?.id === seatDetails?.customer?.id
          ? undefined
          : cartDetails?.selectedCustomer === null
            ? null
            : cartDetails?.selectedCustomer?.id;

      const cartRes = await PutCart(
        {
          id: cartStore?.cart?.id,
          customer_id: nextCustomerId,
          description:
            cartDetails?.cartDescription === seatDetails?.description ? undefined : cartDetails?.cartDescription,
        },
        false,
      );

      if (cartRes.status !== StatusCode.OK) {
        dispatch(showError(t("secure.facility.table_service.table_service_cart.table_service_cart.071")));
        setTableState(prevState => ({ ...prevState, cartLoadingMessage: "" }));
        return;
      }

      ReactDOM.unstable_batchedUpdates(() => {
        void dispatch(loadTableCart({ tableCart: cartRes?.data as ICart }, false));
        void updateActiveTable(cartRes?.data as ICart);
        setTableState(prevState => ({ ...prevState, cartLoadingMessage: "" }));
      });

      dispatch(showSuccess(t("secure.facility.table_service.table_service_cart.table_service_cart.072")));

      if (
        nextCustomerId != null &&
        nextCustomerId !== previousCustomerId
      ) {
        void checkOutstandingBalance(nextCustomerId);
      }
    }
  }

  async function handleMoveCarts(moveSeatInfo: IMoveSeatsState) {
    if (moveSeatInfo.selectedTableId && moveSeatInfo.selectedSeatIds?.length > 0) {
      ReactDOM.unstable_batchedUpdates(() => {
        void closeMoveSeats();
        setTableState(prevState => ({
          ...prevState,
          cartLoadingMessage: t("secure.facility.table_service.table_service_cart.table_service_cart.073"),
        }));
      });
      const register = JSON.parse(localStorage.getItem("register"));
      const moveSeatsRes = await PutMoveSeats(
        {
          table_id: moveSeatInfo.selectedTableId,
          cart_ids: moveSeatInfo.selectedSeatIds,
          register_id: register ? register?.id : undefined,
        },
        false,
      );
      if (moveSeatsRes.status !== StatusCode.OK) {
        dispatch(showError(t("secure.facility.table_service.table_service_cart.table_service_cart.074")));
        setTableState(prevState => ({ ...prevState, cartLoadingMessage: "" }));
        return;
      }
      const tablesRes = await GetTable({ id: cartStore?.activeTable?.id, carts: true, orders: true }, false);
      if (tablesRes.status !== StatusCode.OK) {
        dispatch(showError(t("secure.facility.table_service.table_service_cart.table_service_cart.075")));
        setTableState(prevState => ({ ...prevState, cartLoadingMessage: "" }));
        return;
      }
      // If there are still seats available, load the first seat of the table or keep it the same if the active cart wasn't moved
      if (tablesRes?.data[0]?.carts?.length > 0) {
        const firstCart = tablesRes?.data[0]?.carts[0];
        const updatedActiveCart = tablesRes?.data[0]?.carts?.find(foundCart => foundCart.id === cart?.id) ?? firstCart;
        ReactDOM.unstable_batchedUpdates(() => {
          void dispatch(loadTableCart({ tableCart: updatedActiveCart }, false));
          if (updatedActiveCart?.order) {
            setTableState(prevState => ({ ...prevState, order: updatedActiveCart?.order }));
          }
        });
      } else {
        ReactDOM.unstable_batchedUpdates(() => {
          void dispatch(loadTableCart({ tableCart: null }, false));
          setTableState(prevState => ({ ...prevState, order: undefined }));
        });
      }
      dispatch(showSuccess(t("secure.facility.table_service.table_service_cart.table_service_cart.076")));
      ReactDOM.unstable_batchedUpdates(() => {
        void dispatch(setActiveTable(tablesRes?.data[0]));
        setTableState(prevState => ({ ...prevState, cartLoadingMessage: "" }));
      });
    } else {
      dispatch(showError(t("secure.facility.table_service.table_service_cart.table_service_cart.077")));
    }
  }

  async function handleTransferTable(transferTableInfo: ITransferTableSheetState) {
    if (transferTableInfo?.selectedUserId !== activeTable?.user_id) {
      const transferRes = await PutTable({ id: activeTable?.id, user_id: transferTableInfo?.selectedUserId }, true);

      if (transferRes?.status !== StatusCode.OK) {
        dispatch(showError(t("secure.facility.table_service.table_service_cart.table_service_cart.078")));
        return;
      }
      dispatch(showSuccess(t("secure.facility.table_service.table_service_cart.table_service_cart.079")));
      const updatedTable = transferRes?.data as unknown as ITable;
      void dispatch(setActiveTable({ ...updatedTable, carts: activeTable?.carts }));
      void updateTransferTable({ isOpen: false });

      //Send user to table selection if they do not have permission to access other users' tables
      if (authStore?.user?.id !== updatedTable?.user_id && !permissions?.table_service_table_override) {
        void navigateToTableSelection();
      }
    }
  }

  async function moveLineItemsRefresh() {
    await reloadTable();
    setTableState(prevState => ({ ...prevState, cartLoadingMessage: "" }));
  }

  async function splitLineItemsRefresh() {
    await reloadTable();
    ReactDOM.unstable_batchedUpdates(() => {
      setLineItemState(prevState => ({ ...prevState, showEditLineItemModal: false, selectedLineItem: null }));
      setTableState(prevState => ({ ...prevState, cartLoadingMessage: "" }));
    });
  }

  function closeSplitLineItems() {
    ReactDOM.unstable_batchedUpdates(() => {
      void closeSplitItems();
      setLineItemState(prevState => ({ ...prevState, showEditLineItemModal: false, selectedLineItem: null }));
    });
  }

  function setSendChitIds() {
    let lineItemIds: Array<number> = [];
    //Defaults selected line items in Send Chit Modal
    if (activeTable?.carts) {
      const carts = [...activeTable.carts];
      carts?.forEach(cart => {
        if (cart?.status !== "complete" && (!cart?.order || cart?.order?.financial_status === "unpaid")) {
          const lineItemsToAdd = cart?.line_items
            ?.filter(
              filteredLineItem =>
                !filteredLineItem.parent_id &&
                filteredLineItem?.kitchen_status !== "sent" &&
                (filteredLineItem?.product?.meta?.kitchen_location_id ||
                  filteredLineItem?.product?.meta?.kitchen_location_id_2 ||
                  filteredLineItem?.product?.meta?.kitchen_location_id_3),
            )
            ?.map(lineItem => lineItem?.id);
          lineItemIds = [...lineItemIds, ...lineItemsToAdd];
        }
      });
    }
    return lineItemIds;
  }

  async function loadInventoryLevels(folder: IFolder, cartOrder: IOrder) {
    let productIds: Array<number> = [];
    let variantIds: Array<number> = [];
    const order = { ...cartOrder };
    const selectedFolder = { ...folder };
    //Update inventory levels of purchased items
    order?.line_items?.forEach(lineItem => {
      const foundProduct = selectedFolder?.products?.find(product => product?.id === lineItem?.product_id);
      //Only take variant ids of product that has track_inventory set to true
      if (foundProduct && foundProduct?.track_inventory) {
        if (!productIds?.includes(lineItem?.product_id)) {
          productIds = [...productIds, lineItem?.product_id];
        }
        variantIds = [...variantIds, lineItem?.variant_id];
      }
    });
    if (variantIds?.length > 0) {
      const { status, getQuantity } = await fetchTrackedInventoryQuantities(variantIds, false);
      if (status !== StatusCode.OK) {
        dispatch(showError(t("Error getting inventory details")));
        return;
      }
      const storedProductFolder = await getStoredProductFolder(selectedFolder?.id);
      if (storedProductFolder && productIds?.length > 0) {
        const updatedProducts = applyInventoryQuantitiesToProducts(
          storedProductFolder.products ?? [],
          productIds,
          getQuantity,
        );
        const updatedFolder = { ...storedProductFolder, products: updatedProducts };
        await upsertStoredProductFolder(updatedFolder);
        setTableState(prev => ({ ...prev, selectedFolder: updatedFolder }));
      }
    }
  }

  function processAmountSpentOffer(offer: IOffer) {
    let pointsEarned = 0;
    if (offer?.amount_spent <= 0) {
      return pointsEarned;
    }
    const totalSpent = validateLineItemsTotal();

    if (totalSpent >= offer?.amount_spent) {
      pointsEarned = Math.round(totalSpent) * offer?.points_earned;
    }

    return pointsEarned;
  }

  function validateLineItemsTotal() {
    let lineItemsTotal = 0;
    const excludedDepartmentIds = facilityStore?.loyaltyProgram?.excluded_departments?.map(
      department => department?.id,
    );
    if (cart?.line_items?.length > 0) {
      cart?.line_items?.forEach(lineItem => {
        const lineItemProduct = lineItem?.product;

        //Don't count discounts items if the loyalty program doesn't allow it
        if (facilityStore?.loyaltyProgram?.exclude_discounted_items) {
          const foundDiscount = cart?.discount_lines?.some(line => line?.cart_line_item_id === lineItem?.id);
          if (foundDiscount) {
            return;
          }
        }

        if (lineItem?.loyalty_points_override != null) {
          return;
        }

        //Check if line item's department is excluded from earning points
        if (
          !excludedDepartmentIds?.includes(lineItemProduct?.department_id) &&
          !excludedDepartmentIds?.includes(lineItemProduct?.category_id) &&
          !excludedDepartmentIds?.includes(lineItemProduct?.subcategory_id)
        ) {
          lineItemsTotal += lineItem?.subtotal_price;
        }
      });
    }

    return lineItemsTotal;
  }

  async function getLoyaltyCustomer(customerId: number, cancelToken?: CancelToken) {
    const res = await GetLoyaltyCustomer(
      {
        customer_id: customerId,
        offset: 0,
        tier: facilityStore?.loyaltyProgram?.type === "tier_based" ? true : undefined,
      },
      false,
      cancelToken,
    );
    if (res?.status !== StatusCode.OK) {
      if (cancelToken && cancelToken?.reason) {
        return;
      }
      dispatch(showError(t("Error getting customer loyalty information")));
      return;
    }
    if (res?.data && res?.data?.length >= 1) {
      const loyaltyProgramCustomer = res?.data[0];
      const totalBalance = loyaltyProgramCustomer?.points_balance;
      const totalPointsUsed = cart?.discount_lines
        ?.filter(discount => discount?.loyalty_points_reward_id)
        ?.reduce((total, discount) => total + discount?.loyalty_points_used, 0);
      let totalPointsToEarn = 0;
      const loyaltyOffers = facilityStore?.loyaltyProgramOffers?.filter(offer => offer?.active);
      //Calculate points to earn
      if (totalPointsUsed <= 0 && loyaltyOffers?.length > 0) {
        loyaltyOffers?.forEach(offer => {
          if (offer?.type === "amount_spent") {
            const pointsEarned = processAmountSpentOffer(offer);
            totalPointsToEarn += pointsEarned;
          }
        });
        //Add items with loyalty points override
        cart?.line_items?.forEach(lineItem => {
          if (lineItem?.loyalty_points_override != null) {
            //Don't count discounts items if the loyalty program doesn't allow it
            if (facilityStore?.loyaltyProgram?.exclude_discounted_items) {
              const foundDiscount = cart?.discount_lines?.some(line => line?.cart_line_item_id === lineItem?.id);
              if (foundDiscount) {
                return;
              }
            }
            totalPointsToEarn += lineItem?.loyalty_points_override * lineItem?.quantity;
          }
        });
      }
      const extendedCustomer: ILoyaltyCustomerExtended & { points_available?: number; points_to_earn?: number } = {
        ...loyaltyProgramCustomer,
        customer_first_name: cart?.customer?.first_name,
        customer_last_name: cart?.customer?.last_name,
        customer_email: cart?.customer?.email ?? "",
        customer_type: (cart?.customer as any)?.customer_type?.title ?? (cart?.customer as any)?.customer_type ?? "",
        points_available: totalBalance - totalPointsUsed,
        points_to_earn: totalPointsToEarn,
      };
      setLoyaltyCustomer(extendedCustomer);
    }
  }

  async function applyLoyaltyProgramDiscount(rewardsParam: Array<{ reward_id: number, cart_line_item_id: number }>) {
    if (cart) {
      let updatedCart: ICart = null;

      //Get rewards that were added
      const addedRewards = rewardsParam?.filter(reward => !cart?.discount_lines
        ?.some(discount => discount?.cart_line_item_id === reward?.cart_line_item_id && discount?.loyalty_points_reward_id === reward?.reward_id));
      //Get rewards that were removed
      const removedRewards = cart?.discount_lines?.filter(discountLine => !rewardsParam
        ?.some(reward => reward?.cart_line_item_id === discountLine?.cart_line_item_id && reward?.reward_id === discountLine?.loyalty_points_reward_id));

      //No changes made, close the modal
      if (addedRewards?.length === 0 && removedRewards?.length === 0) {
        void closeRedeemPointsModal();
        return;
      }

      dispatch(enqueue());

      if (removedRewards?.length > 0) {
        //Remove all loyalty rewards discount lines
        const removeRes = await Promise.all(removedRewards
          ?.map(async discountLine => await DeleteDiscountLine({ id: discountLine?.id, cart_id: discountLine?.cart_id }, false)));
        if (removeRes?.some(remove => remove?.status !== StatusCode.OK)) {
          dispatch(dequeue());
          dispatch(showError(t("Error removing loyalty program discount")));
          return;
        }
        updatedCart = removeRes?.reverse()?.find(res => res?.status === StatusCode.OK)?.data;
      }


      if (addedRewards?.length > 0) {
        //Add the newly selected loyalty discounts
        const res = await PostLoyaltyProgramDiscount({ cart_id: cart?.id, reward_line_items: addedRewards }, false);
        if (res?.status !== StatusCode.OK) {
          dispatch(dequeue());
          dispatch(showError(t("Error adding rewards discounts")));
          return;
        }
        updatedCart = res?.data;
      }

      //Fallback if updated cart is not returned
      if (!updatedCart) {
        const cartRes = await GetCart({ id: cart?.id }, false);
        if (cartRes?.status !== StatusCode.OK) {
          dispatch(dequeue());
          dispatch(showError(t("Error updating cart")));
          return;
        }
        updatedCart = cartRes?.data;
      }

      dispatch(dequeue());
      //Set updated cart
      ReactDOM.unstable_batchedUpdates(() => {
        void dispatch(loadTableCart({ tableCart: updatedCart }, false));
        void updateActiveTable(updatedCart);
      });

      dispatch(showSuccess(t("Successfully added reward discounts")));
      void closeRedeemPointsModal();
    }
  }

  function handleInvoiceOk(selectedInvoice: IInvoice) {
    updateInvoiceModal(({ isOpen: false, selectedInvoice: selectedInvoice }));
  }

  async function printAllReceipts() {
    if (cartStore?.activeTable?.carts) {
      const printableCarts = cartStore.activeTable.carts.filter(
        cart => cart?.status !== "void" && cart?.status !== "complete",
      );
      if (!printableCarts.length) {
        dispatch(showError(t("Error printing receipts")));
        return;
      }
      const receipts: Array<{id: number; type: "cart" | "order"}> = printableCarts.map(cart => cart?.order && cart?.order?.financial_status !== "unpaid" ? {id: cart?.order_id, type: "order"} : {id: cart?.id, type: "cart"});
      const receiptRes = await GetPrintBulkReceipts({ receipts: receipts}, true);
      if (receiptRes.status === StatusCode.OK) {
        printDesktopReceipt(facilityStore.facility?.id, receiptRes.data.toString() as string);
      } else {
        dispatch(showError(t("Error printing receipts")));
      }
    }
  }

  async function applyLoyaltyCashBackDiscount(reward: Array<{reward_id: number; points_to_use: number, cart_line_item_id: number}>) {
    if (cart) {
      dispatch(enqueue());
      const removeReward = cart?.discount_lines?.find(
        discountLine =>
          reward?.some(
            r =>
              r?.reward_id === discountLine?.loyalty_points_reward_id,
          ),
      );
      if (removeReward) {
        const res = await DeleteDiscountLine({ id: removeReward?.id, cart_id: cart?.id}, false);
        if (res?.status !== StatusCode.OK) {
          dispatch(dequeue());
          dispatch(showError(errorMessage(res, t("Error removing rewards discount"))));
          return;
        }
      }
      let updatedCart: ICart = null;
      const res = await PostLoyaltyProgramDiscount({ cart_id: cart?.id, reward_line_items: reward }, false);
      dispatch(dequeue());
      if (res?.status !== StatusCode.OK) {
        dispatch(showError(errorMessage(res, t("Error adding rewards discounts"))));
        return;
      }
      updatedCart = res?.data;
          //Fallback if updated cart is not returned
        if (!updatedCart) {
          const cartRes = await GetCart({ id: cart?.id }, false);
          if (cartRes?.status !== StatusCode.OK) {
            dispatch(showError(t("Error updating cart")));
            return;
          }
          updatedCart = cartRes?.data[0];
        }
          //Set updated cart
          void dispatch(loadTableCart({ tableCart: updatedCart }, false));
        
        dispatch(showSuccess(t("Successfully added reward discount")));
        void closeRedeemPointsModal();
      }
  }

  async function removeCashbackDiscount(id: number) {
    let updatedCart: ICart = null;
    const res = await DeleteDiscountLine({ id, cart_id: cart?.id}, true);
    if (res?.status !== StatusCode.OK) {
      dispatch(showError(errorMessage(res, t("Error removing rewards discount"))));
      return;
    }
       //Fallback if updated cart is not returned
       if (!updatedCart) {
        const cartRes = await GetCart({ id: cart?.id }, false);
        if (cartRes?.status !== StatusCode.OK) {
          dispatch(showError(t("Error updating cart")));
          return;
        }
        updatedCart = cartRes?.data[0];
      }
        //Set updated cart
        void dispatch(loadTableCart({ tableCart: updatedCart }, false));

      dispatch(showSuccess(t("Successfully removed reward discount")));
      void closeRedeemPointsModal();
  }

  const cartLoading =
    loadingVariants?.current?.length > 0 || lineItemsUpdating?.current?.length > 0 || !!cartLoadingMessage;

  const tableActions: IAction[] = [
    {
      icon: faReceipt,
      onClick: () => updatePrintChits({ isOpen: true }),
      label: t("secure.facility.table_service.table_service_cart.table_service_cart.080"),
      disabled: !cart,
    },
    {
      icon: faPrint,
      onClick: () => printAllReceipts(),
      label: t("Print All Receipts"),
      disabled: !cart,
    },
    {
      icon: faFire,
      onClick: () => {
        void sendFireChit();
      },
      label: t("secure.facility.table_service.table_service_cart.table_service_cart.081"),
      disabled: !cart,
    },

    ...(activeTable?.carts?.length > 0
      ? [
        {
          icon: faChair,
          onClick: () => updateMoveSeats({ isOpen: true }),
          label: t("secure.facility.table_service.table_service_cart.table_service_cart.082"),
          disabled: false,
        },
        {
          icon: faTurnDownRight,
          onClick: () => updateMoveItems({ isOpen: true }),
          label: t("secure.facility.table_service.table_service_cart.table_service_cart.083"),
          disabled: (cartStore.activeTable?.carts?.filter(isSeatAbleToMoveLineItems) ?? []).length < 2,
        },
      ]
      : []),
    {
      icon: faRightLeft,
      onClick: () => updateTransferTable({ isOpen: true }),
      label: t("secure.facility.table_service.table_service_cart.table_service_cart.084"),
      disabled: false,
    },
    {
      icon: faXmark,
      onClick: handleOpenCloseTableModal,
      label: t("secure.facility.table_service.table_service_cart.table_service_cart.085"),
      disabled: false,
    },
    {
      icon: faNote,
      onClick: () => updateViewNoteModal({ isOpen: true, addNote: cart?.notes ?? "" }),
      label: t("Order Notes"),
      disabled: cart?.order?.financial_status === "paid",
    },
  ];

  const seatActions: IAction[] = [
    ...(cart?.line_items.length > 0
      ? [
        {
          icon: faBan,
          onClick: handleVoidSeatClick,
          label: t("secure.facility.table_service.table_service_cart.table_service_cart.086"),
          disabled: !permissions.orders_void,
        },
      ]
      : [
        {
          icon: faXmark,
          onClick: () => updateCloseSeat({ isOpen: true }),
          label: t("secure.facility.table_service.table_service_cart.table_service_cart.087"),
          disabled: order?.financial_status === "partially_paid" || !cart ? true : false,
        },
      ]),

    {
      icon: faPercent,
      onClick: () => setSeatDiscountModal(prevState => ({ ...prevState, isOpen: true })),
      label: t("Apply Discount"),
      disabled:
        cartLoading ||
        !cart ||
        !(cart?.line_items?.length > 0) ||
        !(facilityStore?.discountOptions?.length > 0) ||
        !permissions?.orders_apply_discount ||
        cart?.status === "complete" ||
        cart?.status === "void",
    },

    ...(showDisableDiscountsOption(cart)
      ? [
        {
          icon: faPercent,
          onClick: () => {
            void handleToggleDisableAutoDiscounts();
          },
          label: isAutoDiscountsDisabled(cart) ? t("Enable Discounts") : t("Disable Discounts"),
          disabled: cartLoading || !cart,
        },
      ]
      : []),

    {
      icon: faArrowRotateLeft,
      onClick: () => updateClearSeat({ isOpen: true }),
      label: t("secure.facility.table_service.table_service_cart.table_service_cart.088"),
      disabled:
        !cart || order?.financial_status === "partially_paid" || cart?.status === "complete" || cart?.status === "void"
          ? true
          : false,
    },

    {
      icon: faTicket,
      onClick: () => void handleOpenRedeemTicket(),
      label: t("Redeem Ticket"),
      disabled:
        !cart || order?.financial_status === "partially_paid" || cart?.status === "complete" || cart?.status === "void"
          ? true
          : false,
    },

    {
      icon: faArrowsRotate,
      onClick: () => updateMergeSeats({ isOpen: true }),
      label: t("secure.facility.table_service.table_service_cart.table_service_cart.089"),
      disabled:
        !cart ||
          order?.financial_status === "partially_paid" ||
          cart?.status === "complete" ||
          cart?.status === "void" ||
          activeTable?.carts?.filter(
            filterCart =>
              filterCart?.id !== cart?.id &&
              filterCart?.status !== "complete" &&
              filterCart?.status !== "void" &&
              filterCart?.order?.financial_status !== "partially_paid",
          )?.length < 1
          ? true
          : false,
    },

    {
      icon: faFileLines,
      onClick: () => handleOpenCartDetailsSheet(),
      label: t("secure.facility.table_service.table_service_cart.table_service_cart.090"),
      disabled:
        !cart || order?.financial_status === "partially_paid" || cart?.status === "complete" || cart?.status === "void",
    },

    {
      icon: faNotes,
      onClick: () => updateViewChits({ isOpen: true }),
      label: t("secure.facility.table_service.table_service_cart.table_service_cart.091"),
      disabled: false,
    },

    {
      icon: faListUl,
      onClick: () => setViewCartAudit(true),
      label: t("Seat activity"),
      disabled: false,
    },
  ];

  const elementsComplete =
    manualStripeState.elementComplete.cardNumber === true &&
    manualStripeState.elementComplete.cardExpiry === true &&
    manualStripeState.elementComplete.cardCvc === true;

  const seatButtons = activeTable?.carts?.map((seatCart, index) => {
    return (
      <button
        key={index}
        disabled={cartLoading || !!cartLoadingMessage}
        onClick={() => handleSelectSeat(seatCart)}
        className={classNames("active-table-seats-button", {
          "active-table-seats-button-selected": seatCart?.token === cart?.token,
          [`active-table-seats-button-${seatCart?.status}`]: seatCart?.status,
          [`active-table-seats-button-${seatCart?.status}-selected`]:
            seatCart?.status && seatCart?.token === cart?.token,
          [`active-table-seats-button-${seatCart?.order?.financial_status}`]: seatCart?.order?.financial_status,
          [`active-table-seats-button-${seatCart?.order?.financial_status}-selected`]:
            seatCart?.order?.financial_status && seatCart?.token === cart?.token,
        })}
      >
        <span className="active-table-seats-button-number">{index + 1}</span>
        {seatCart?.customer ? (
          <p className="active-table-seats-button-initals">{`(${seatCart.customer.first_name?.charAt(0)}${seatCart.customer.last_name?.charAt(0)})`}</p>
        ) : null}
      </button>
    );
  });

  const addSeatButton = (
    <button
      className={classNames("active-table-seats-button", "active-table-seats-button-add")}
      onClick={() => {
        void handleAddSeat();
      }}
      disabled={cartLoading || addingSeat}
    >
      <FontAwesomeIcon icon={faPlus} fixedWidth />
    </button>
  );

  return (
    <div
      className={classNames("table-service-cart", {
        "table-service-cart--overlay": isOverlay,
      })}
    >
      {mobileSeatBar ? (
        <div className="active-table-seats active-table-seats--mobile" ref={seatsBarRef}>
          <div className="active-table-seats-scroll-wrap">
            <div className="active-table-seats-scroll" ref={seatsScrollRef}>
              <div className="active-table-seats-container">{seatButtons}</div>
            </div>
            <button
              type="button"
              className="active-table-seats-button active-table-seats-chevron active-table-seats-chevron--left"
              aria-label="Scroll seats left"
              onClick={() => handleSeatsChevronScroll("left")}
            >
              <FontAwesomeIcon icon={faChevronLeft} fixedWidth />
            </button>
            <button
              type="button"
              className="active-table-seats-button active-table-seats-chevron active-table-seats-chevron--right"
              aria-label="Scroll seats right"
              onClick={() => handleSeatsChevronScroll("right")}
            >
              <FontAwesomeIcon icon={faChevronRight} fixedWidth />
            </button>
          </div>
          {addSeatButton}
        </div>
      ) : (
        <div className="active-table-seats-container">
          {seatButtons}
          {addSeatButton}
        </div>
      )}

      <div className="flex gap-2 items-center">
        <NewBadgeGroup
          primaryContent={cart?.customer?.full_name}
          secondaryContent={cart?.description}
          icon={cart?.status === "complete" ? faCircleDollar : null}
          badgeGroupStyle="tertiary"
          badgeGroupType="default"
          badgeGroupSize="small"
          onClick={cartLoadingMessage ? undefined : () => handleOpenCartDetailsSheet()}
        />
        {loyaltyCustomer && facilityStore?.loyaltyProgram && facilityStore?.loyaltyProgram?.type === "points_based" ? (
          <p className="ui-register-cart-new-points">
            Points balance:{" "}
            <span
              className={classNames({
                "ui-register-cart-new-points-strike":
                  loyaltyCustomer?.points_available < loyaltyCustomer?.points_balance &&
                  !(
                    order?.financial_status === "partially_paid" ||
                    cart?.status === "complete" ||
                    cart?.status === "void"
                  ),
              })}
            >
              {loyaltyCustomer?.points_balance}
            </span>
            {loyaltyCustomer?.points_available < loyaltyCustomer?.points_balance &&
              !(
                order?.financial_status === "partially_paid" ||
                cart?.status === "complete" ||
                cart?.status === "void"
              ) ? (
              <span>
                <FontAwesomeIcon icon={faArrowRight} /> {loyaltyCustomer?.points_available}
              </span>
            ) : null}
          </p>
        ) : null}

        {loyaltyCustomer && facilityStore?.loyaltyProgram && facilityStore?.loyaltyProgram?.type === "tier_based" ? (
          <p className="ui-register-cart-new-points">
            {loyaltyCustomer?.selected_tier?.title
              ? `${t("Tier")}: ${loyaltyCustomer?.selected_tier?.title}`
              : t("No Tier")}{" "}
            •{" "}
            <span
              className={classNames({
                "ui-register-cart-new-points-strike":
                  loyaltyCustomer?.points_available < loyaltyCustomer?.points_balance &&
                  !(
                    order?.financial_status === "partially_paid" ||
                    cart?.status === "complete" ||
                    cart?.status === "void"
                  ),
              })}
            >
              {loyaltyCustomer?.points_balance}
            </span>
            {loyaltyCustomer?.points_available < loyaltyCustomer?.points_balance &&
              !(
                order?.financial_status === "partially_paid" ||
                cart?.status === "complete" ||
                cart?.status === "void"
              ) ? (
              <span>
                <FontAwesomeIcon icon={faArrowRight} /> {loyaltyCustomer?.points_available}
              </span>
            ) : null}{" "}
            {t("pts")}
          </p>
        ) : null}
      </div>

      {cart?.notes ? <p className="ui-register-cart-new-customer-subtitle mt-2 mb-2">{`Order Notes: ${cart.notes}`}</p> : null}

      {facilityStore?.kitchenCourses?.length > 0 && (
        <div className="table-service-course-container" style={{ flexShrink: "0" }}>
          {facilityStore?.kitchenCourses?.map((course, index) => {
            return (
              <span
                key={index}
                onClick={() => selectCourse(course?.id)}
                className={classNames("table-service-course-badge", {
                  "table-service-course-badge-selected": selectedCourseId === course?.id,
                })}
              >
                <Badge type={selectedCourseId === course?.id ? "primary" : "gray"} size="medium">
                  {course?.title}
                </Badge>
              </span>
            );
          })}
        </div>
      )}

      <div className="table-service-cart-line-items" ref={flyToCartTargetRef}>
        {!isEmpty(cartLoadingMessage) ? (
          <div style={{ display: "flex", margin: "auto 0", height: "100%" }}>
            <div className="text-center m-auto">
              <div style={{ height: "32px" }}>
                <Spin />
              </div>
              <div>{cartLoadingMessage}</div>
            </div>
          </div>
        ) : (
          <>
            <TableServiceCartLineItems
            handleDiscountClick={
              cart?.status !== "complete" && order?.financial_status !== "partially_paid" && cart?.status !== "void"
                ? (discountLine, parentLineItemId) =>
                  setDiscountState(prevState => ({
                    ...prevState,
                    showModal: true,
                    selectedDiscount: discountLine,
                    parentLineItemId: parentLineItemId ? parentLineItemId : null,
                  }))
                : undefined
            }
            handleLineItemClick={
              cart?.status !== "complete" && order?.financial_status !== "partially_paid" && cart?.status !== "void"
                ? item =>
                  setLineItemState(prevState => ({
                    ...prevState,
                    selectedLineItem: item,
                    showEditLineItemModal: true,
                  }))
                : undefined
            }
            lineItems={cart?.line_items}
            discountLines={cart?.discount_lines}
            currency={cart?.currency}
            allowLineItemAutoScroll={allowLineItemAutoScroll}
            onSearchProduct={onSearchProduct}
          />
          </>
        )}
      </div>

      {cart && isEmpty(cartLoadingMessage) && (
        <div className="table-service-cart-totals">
          <CartTotalsNew
            currency={cart?.currency}
            subTotal={cart?.subtotal_price}
            taxLines={cart?.tax_lines}
            totalTip={cart?.total_tip}
            total={cart?.total_price}
            order={order}
            handleTipTeeSheet={(tipAmount, tipAllocations) => {
              void handleAddTip(tipAmount, tipAllocations);
            }}
            cart={cart}
            pointsToEarn={loyaltyCustomer?.points_to_earn}
            totalServiceFee={cart?.service_fee_total}
            handleAddServiceFee={serviceFeeId => {
              void handleAddServiceFee(serviceFeeId);
            }}
            handleClearServiceFee={handleClearServiceFee}
          />
        </div>
      )}

      {cart?.order && <CartTransactions transactions={cart?.order?.transactions} currency={order?.currency} />}

      <div className="active-table-cart-button-group">
        <Button
          disabled={
            !cart ||
            cart?.line_items?.length === 0 ||
            cart?.status === "complete" ||
            cartLoading ||
            cart?.status === "void"
          }
          block
          size="medium"
          type="primary"
          onClick={handlePrePaymentChecks}
          loading={paymentState?.paymentInProgress}
        >
          {t('Pay')}
        </Button>
        <div className="active-table-secondary-buttons">
          <Button
            disabled={cartLoading}
            block
            size="medium"
            type="secondary"
            onClick={() => updateSendChits({ isOpen: true })}
          >
            <FontAwesomeIcon className="mr-2" icon={faPaperPlane} size="1x" />{" "}
            {t("secure.facility.table_service.table_service_cart.table_service_cart.092")}
          </Button>
          <Button
            block
            size="medium"
            type="secondary"
            disabled={!cart || cartLoading}
            onClick={() =>
              order && order.financial_status !== "unpaid"
                ? void printReceipt(order?.id, "order")
                : void printReceipt(cart?.id, "cart")
            }
          >
            <FontAwesomeIcon className="mr-2" icon={faReceipt} size="1x" />{" "}
            {t("secure.facility.table_service.table_service_cart.table_service_cart.093")}
          </Button>
          <Button
            disabled={cartLoading}
            block
            size="medium"
            type="secondary"
            onClick={() => setActionsState(prevState => ({ ...prevState, showActionsModal: true }))}
          >
            {" "}
            <FontAwesomeIcon className="mr-2" icon={faGripDots} size="1x" />{" "}
            {t("secure.facility.table_service.table_service_cart.table_service_cart.094")}
          </Button>
          {loyaltyCustomer &&
            !(
              !cart ||
              order?.financial_status === "partially_paid" ||
              cart?.status === "complete" ||
              cart?.status === "void" ||
              cartLoading ||
              cart?.total_price === 0
            ) ? (
            <Button type="secondary" block onClick={() => updateRedeemPointsModal({ isOpen: true })}>
              <span className="mr-2">
                <FontAwesomeIcon icon={faStar} />
              </span>
              {t("Redeem")}
            </Button>
          ) : null}
        </div>
      </div>

      {lineItemState?.selectedLineItem && (
        <EditLineItemModal
          open={lineItemState.showEditLineItemModal}
          lineItem={lineItemState.selectedLineItem}
          onCancel={() =>
            setLineItemState(prevState => ({ ...prevState, showEditLineItemModal: false, selectedLineItem: null }))
          }
          removeLineItem={handleRemoveLineItem}
          update={updatedLineItem => handleUpdateLineItem(updatedLineItem)}
          openSplitItemModal={() => updateSplitItems({ isOpen: true })}
          openModifierModal={lineItem => updateRegisterState({ modifierLineItem: lineItem })}
          openDynamicComboModal={lineItem => updateRegisterState({ dynamicComboLineItem: lineItem })}
          courses
          currency={cart?.currency}
          cart={cart}
        />
      )}

      <Popup
        type="warning"
        open={discountState.showModal}
        title={t("secure.facility.table_service.table_service_cart.table_service_cart.095")}
        description={t("secure.facility.table_service.table_service_cart.table_service_cart.096")}
        closable
        onOk={() => {
          void removeDiscountLine();
        }}
        onCancel={() =>
          setDiscountState(prevState => ({
            ...prevState,
            showModal: false,
            selectedDiscount: null,
            parentLineItemId: null,
          }))
        }
        okText={t("secure.facility.table_service.table_service_cart.table_service_cart.097")}
      />

      {facilityStore?.discountOptions && (
        <DiscountLineItemModal
          title={t("Apply Discount to Seat")}
          open={seatDiscountModal.isOpen}
          onCancel={() => setSeatDiscountModal(initialSeatDiscountModalState)}
          onOk={(customAmount, typeFixed) => void handleApplySeatDiscount(customAmount, typeFixed)}
          noteDiscount={seatDiscountModal.noteDiscount}
          changeNoteState={(e: React.ChangeEvent<HTMLInputElement>) =>
            setSeatDiscountModal(prevState => ({ ...prevState, noteDiscount: e.target.value }))
          }
          onChange={(id: number, discount: IDiscount) =>
            setSeatDiscountModal(prevState => ({ ...prevState, selectedDiscountId: id, selectedDiscount: discount }))
          }
          okDisabled={!seatDiscountModal.selectedDiscountId || seatDiscountModal.selectedDiscountId < 0}
          discounts={facilityStore?.discountOptions}
          selectedDiscount={seatDiscountModal.selectedDiscount}
        />
      )}

      <Popup
        type="warning"
        open={closeTable?.isOpen}
        title={t("secure.facility.table_service.table_service_cart.table_service_cart.098")}
        description={
          closeTable?.partiallyPaidSeats ||
            !!closeTable?.loadingMessage ||
            (closeTable?.voidSeats && !permissions?.orders_void)
            ? ""
            : t("secure.facility.table_service.table_service_cart.table_service_cart.099")
        }
        closable
        onOk={() => {
          if (closeTable?.partiallyPaidSeats) {
            void handleRefundBeforeCloseTable();
            return;
          }
          void handleCloseTable();
        }}
        okText={
          closeTable?.partiallyPaidSeats
            ? t("Refund payments & void")
            : t("secure.facility.table_service.table_service_cart.table_service_cart.100")
        }
        cancelText={t("secure.facility.table_service.table_service_cart.table_service_cart.101")}
        onCancel={() => {
          if (!refundingPayments) {
            cancelCloseTable();
          }
        }}
        backDropCancel={false}
        loading={refundingPayments}
        cancelDisabled={!!closeTable.loadingMessage || refundingPayments}
        okDisabled={
          refundingPayments ||
          !!closeTable?.loadingMessage ||
          (closeTable?.voidSeats && !closeTable?.partiallyPaidSeats && !permissions?.orders_void)
        }
      >
        {closeTable?.loadingMessage ? (
          <div style={{ display: "flex", height: "100%" }}>
            <div className="text-center m-auto">
              <div style={{ height: "32px" }}>
                <Spin />
              </div>
              <div>{closeTable?.loadingMessage}</div>
            </div>
          </div>
        ) : closeTable?.partiallyPaidSeats ? (
          <div className="mt-4">
            <p>
              <b>{t("secure.facility.table_service.table_service_cart.table_service_cart.102")}</b>
            </p>
            <p className="mt-2">
              {t(
                "One or more seats have payments already collected. Refund payments returns money to the original payment methods, then voids those orders so the table can close. Hand cash/check back to the customer.",
              )}
            </p>
            <div style={{ marginTop: "12px" }}>
              <Button
                type="error-outline"
                block
                disabled={refundingPayments}
                onClick={() => {
                  updateCloseTable({ partiallyPaidSeats: false });
                  void handleCloseTable({ skipPartialPaymentCheck: true });
                }}
              >
                {t("Void without refunding")}
              </Button>
            </div>
          </div>
        ) : closeTable?.voidSeats && permissions?.orders_void ? (
          <div className="mt-4">
            <p>
              <b>{t("secure.facility.table_service.table_service_cart.table_service_cart.103")}</b>
            </p>
            <Divider />
            <Select
              label={t("secure.facility.table_service.table_service_cart.table_service_cart.104")}
              defaultValue={voidSeat.cancel_reason}
              onChange={(value: string) => updateCloseTable({ cancel_reason: value })}
              usePortal
            >
              {cancel_reasons(t).map((reason, index) => (
                <Option key={index} value={reason.title} name={reason.title}>
                  {reason.title}
                </Option>
              ))}
            </Select>
          </div>
        ) : closeTable?.voidSeats && !permissions?.orders_void ? (
          <div className="mt-4">
            <p>
              <b>{t("secure.facility.table_service.table_service_cart.table_service_cart.105")}</b>
            </p>
          </div>
        ) : closeTable?.seatsOpen ? (
          <div className="mt-4">
            <p>
              <b>{t("secure.facility.table_service.table_service_cart.table_service_cart.106")}</b>
            </p>
          </div>
        ) : null}
      </Popup>

      <Popup
        open={clearSeat?.isOpen}
        type="warning"
        title={t("secure.facility.table_service.table_service_cart.table_service_cart.107")}
        description={t("secure.facility.table_service.table_service_cart.table_service_cart.108")}
        onOk={handleClearCart}
        okText={t("secure.facility.table_service.table_service_cart.table_service_cart.109")}
        cancelText={t("secure.facility.table_service.table_service_cart.table_service_cart.101")}
        onCancel={closeClearSeat}
        backDropCancel={true}
      />

      <Popup
        type="warning"
        open={closeSeat?.isOpen}
        title={t("secure.facility.table_service.table_service_cart.table_service_cart.110")}
        description={t("secure.facility.table_service.table_service_cart.table_service_cart.111")}
        closable
        onOk={handleSeatCartClose}
        okText={t("secure.facility.table_service.table_service_cart.table_service_cart.100")}
        backDropCancel
        cancelText={t("secure.facility.table_service.table_service_cart.table_service_cart.101")}
        onCancel={closeCloseSeat}
      />

      <Popup
        type="warning"
        open={voidSeat.isOpen}
        title={t("secure.facility.table_service.table_service_cart.table_service_cart.112")}
        description={""}
        closable
        onOk={() => void handleSeatCartVoid()}
        okText={t("secure.facility.table_service.table_service_cart.table_service_cart.100")}
        backDropCancel
        cancelText={t("secure.facility.table_service.table_service_cart.table_service_cart.101")}
        onCancel={closeVoidSeat}
        okDisabled={!voidSeat.cancel_reason ? true : false}
      >
        <div>
          <Select
            label={t("secure.facility.table_service.table_service_cart.table_service_cart.113")}
            defaultValue={voidSeat.cancel_reason}
            onChange={(value: string) => updateVoidSeat({ cancel_reason: value })}
            usePortal
          >
            {cancel_reasons(t).map((reason, index) => (
              <Option key={index} value={reason.title} name={reason.title}>
                {reason.title}
              </Option>
            ))}
          </Select>
        </div>
      </Popup>

      <Popup
        type="warning"
        open={showRefundBeforeVoidSeat}
        title={t("Payments already processed")}
        description={
          getOrderNetCollected(getSeatOrder(cart)?.transactions) > 0
            ? `This seat has ${displayCurrency(
                getSeatOrder(cart)?.currency,
                getOrderNetCollected(getSeatOrder(cart)?.transactions),
              )} already collected. Refund payments returns money to the original payment methods, then voids the order and seat. Hand cash/check back to the customer.`
            : "This seat has payments already processed. Refund payments returns money to the original payment methods, then voids the order and seat. Hand cash/check back to the customer."
        }
        closable
        loading={refundingPayments}
        okDisabled={refundingPayments}
        cancelDisabled={refundingPayments}
        onOk={() => void handleRefundBeforeVoidSeat()}
        onCancel={() => {
          if (!refundingPayments) {
            setShowRefundBeforeVoidSeat(false);
          }
        }}
        okText={t("Refund payments & void")}
        cancelText={t("Cancel")}
      >
        <div style={{ marginTop: "12px" }}>
          <Button
            type="error-outline"
            block
            disabled={refundingPayments}
            onClick={handleContinueVoidSeatWithoutRefund}
          >
            {t("Void without refunding")}
          </Button>
        </div>
      </Popup>

      {stripePaymentState.processing ? (
        <Popup
          type="info"
          open={stripePaymentState.sheetVisible}
          title={t("secure.facility.table_service.table_service_cart.table_service_cart.114")}
          description={t("secure.facility.table_service.table_service_cart.table_service_cart.115")}
          closable
          onCancel={stripePaymentState.onCancel}
          onOk={stripePaymentState.onOk}
          cancelText={stripePaymentState.cancelText}
          okText={stripePaymentState.okText}
          backDropCancel={false}
        />
      ) : (
        <>
          {stripePaymentState.success ? (
            <Popup
              type="success"
              open={stripePaymentState.sheetVisible}
              title={t("secure.facility.table_service.table_service_cart.table_service_cart.116")}
              description={t("secure.facility.table_service.table_service_cart.table_service_cart.117")}
              closable
              onCancel={stripePaymentState.onCancel}
              onOk={stripePaymentState.onOk}
              cancelText={stripePaymentState.cancelText}
              okText={stripePaymentState.okText}
              backDropCancel={false}
            />
          ) : (
            <Popup
              type="error"
              open={stripePaymentState.sheetVisible}
              title={t("secure.facility.table_service.table_service_cart.table_service_cart.118")}
              description={
                stripePaymentState.message +
                t("secure.facility.table_service.table_service_cart.table_service_cart.119") +
                stripePaymentState.convertedCode
              }
              closable
              onCancel={stripePaymentState.onCancel}
              onOk={stripePaymentState.onOk}
              cancelText={stripePaymentState.cancelText}
              okText={stripePaymentState.okText}
              backDropCancel={false}
            />
          )}
        </>
      )}

      <StripeTerminalSheet />
      <StripeTerminalRefundSheet />

      <CartAuditTrailDrawer
          open={viewCartAudit}
          onClose={() => setViewCartAudit(false)}
          cart={cart}
          tableServiceCarts={activeTable?.carts}
        />

      <GiftCardSell
        gift_cards={paymentState.gift_cards}
        sellGiftCardsActive={paymentState.sellGiftCardsActive}
        onOk={() => {
          void handleAddSellGiftCards();
        }}
        onCancel={cancelGiftCardsAndLeagues}
        setGiftCards={gift_cards =>
          setPaymentState(prev => ({ ...prev, gift_cards }))
        }
      />

      <GiftCardRedeem
        redeemGiftCardsActive={paymentState.giftCardModalVisible}
        onOk={giftCardInfo => {
          void handleProcessPayment(giftCardInfo);
        }}
        onCancel={() =>
          setPaymentState(prevState => ({
            ...prevState,
            giftCardModalVisible: false,
            paymentInProgress: false,
          }))
        }
        cart={cartStore?.cart}
      />

      <LeagueSelectionModal
        open={paymentState.leagueFeesActive}
        leagueFeeProducts={paymentState.leagueFeeProducts}
        onCancel={cancelGiftCardsAndLeagues}
        onOk={setSelectedLeagues}
      />

      <AccountsModal
        loadAccounts={paymentState.accountsVisible}
        onCancel={() =>
          setPaymentState(prevState => ({
            ...prevState,
            accountsVisible: false,
            selectedAccount: undefined,
          }))
        }
        onOk={account =>
          setPaymentState(prevState => ({ ...prevState, accountsVisible: false, selectedAccount: account }))
        }
        customerId={cartStore?.cart?.customer_id}
        searchAccountPermission={permissions?.accounts_charge_all}
      />

      <CreditBookModal
        loadCreditBooks={modalCreditBook.isOpen}
        onCancel={() => closeCreditBook()}
        onOk={(selectedCreditBook: IPrizeAccount) =>
          updateCreditBook({ selectedCreditBook: { ...selectedCreditBook } })
        }
        customerId={cartStore?.cart?.customer?.id}
      // searchAccountPermission={permissions?.credit}
      />

      <Portal isMounted={invoiceModal.isOpen}>
        <InvoiceModal
          loadInvoices={invoiceModal.isOpen}
          onCancel={closeInvoiceModal}
          onOk={handleInvoiceOk}
          customerId={cartStore?.cart?.customer?.id}
        />
      </Portal>

      <ActionModal
        open={actionsState.showActionsModal}
        setOpen={(open: boolean) => setActionsState(prevState => ({ ...prevState, showActionsModal: open }))}
        actionGroups={[tableActions, seatActions]}
      />

      {sendChits?.isOpen && (
        <TableServiceSendLineItemsModal
          open={sendChits?.isOpen}
          selectedIds={setSendChitIds()}
          onOk={lineItemIds => handleSendChit(lineItemIds)}
          onCancel={cancelSendChits}
          activeTable={activeTable}
        />
      )}

      <Portal isMounted={printChitsState?.isOpen}>
        <PrintChit
          printOrderVisible={printChitsState?.isOpen}
          onCancel={cancelPrintChits}
          onOk={chits => {
            void handlePrintReceipt(chits);
          }}
          activeTable={activeTable}
        />
      </Portal>

      <MergeSeats
        mergeSeatsVisible={mergeSeats?.isOpen}
        onCancel={closeMergeSeats}
        onOk={mergeInfo => void handleSeatMerge(mergeInfo)}
      />

      <EditSeatDetails
        editSeatVisible={seatDetails.isOpen}
        onCancel={closeSeatDetails}
        onOk={details => void handleUpdateCartDetails(details)}
        prevCartDetails={{
          customer: seatDetails.customer,
          description: seatDetails.description,
        }}
      />

      <TransferTableSheet
        modalVisibility={transferTable.isOpen}
        onCancel={() => updateTransferTable({ isOpen: false })}
        onOk={info => void handleTransferTable(info)}
        users={transferTable.users}
      />

      {viewChits?.isOpen && (
        <TableServiceKitchenChitModal
          isVisible={viewChits?.isOpen}
          closeModal={() => closeViewChits()}
          user_id={authStore?.user?.id}
          forceRefresh={forceRefreshChits}
          setForceRefresh={setForceRefreshChits}
        />
      )}

      <MoveSeats
        addToTableModalVisible={moveSeats?.isOpen}
        onCancel={closeMoveSeats}
        onOk={info => void handleMoveCarts(info)}
      />

      <TableServiceMoveLineItemsModal
        open={moveItems.isOpen}
        seats={activeTable?.carts}
        onCancel={closeMoveItems}
        onRefresh={() => void moveLineItemsRefresh()}
        setTableState={setTableState}
      />

      <SplitLineItemsModal
        onCancel={closeSplitLineItems}
        onRefresh={splitLineItemsRefresh}
        open={splitItems?.isOpen}
        selectedLineItemId={lineItemState?.selectedLineItem?.id}
        setTableState={setTableState}
      />

      {/* Redeem Loyalty Points Based */}
      <RedeemPointsModal
        open={redeemPointsModal?.isOpen && facilityStore?.loyaltyProgram?.type === "points_based"}
        onCancel={closeRedeemPointsModal}
        customer={loyaltyCustomer}
        lineItems={cart?.line_items}
        discountLines={cart?.discount_lines}
        onOk={rewards => applyLoyaltyProgramDiscount(rewards)}
      />

      <RedeemTierPointsModal
        open={redeemPointsModal?.isOpen && facilityStore?.loyaltyProgram?.type === "tier_based"}
        onCancel={closeRedeemPointsModal}
        customer={loyaltyCustomer}
        lineItems={cart?.line_items}
        discountLines={cart?.discount_lines}
        onOk={rewards => applyLoyaltyProgramDiscount(rewards)}
      />

      {/* Cash back reward program */}
      <RedeemCashbackPointsModal
          open={redeemPointsModal?.isOpen && facilityStore?.loyaltyProgram?.type === "cash_back"}
          onCancel={closeRedeemPointsModal}
          customer={loyaltyCustomer}
          currency={cart?.currency}
          discountLines={cart?.discount_lines}
          onOk={reward => applyLoyaltyCashBackDiscount(reward)}
          subtotal={cart?.subtotal_price}
          handleRemove={removeCashbackDiscount}
        />

      {/* Customer deposits */}
      <CustomerDepositsModal 
          open={customerDepositsModal?.isOpen} 
          onOk={(deposit, amountToApply) => {
            void updateCustomerDepositsModal({isOpen: false});
            void handleProcessPayment(null, {...deposit, amountToApply});
          }} 
          onClose={closeCustomerDepositsModal} 
          customerId={cart?.customer_id}   
          cartAmount={String(paymentState.paymentAmount)}     
          />

      {outstandingBalancePopup}

      <Sheet
        title={t("secure.facility.table_service.table_service_cart.table_service_cart.120")}
        open={paymentState.roomChargeSheetVisible}
        size="small"
        closable
        onCancel={() =>
          setPaymentState(prevState => ({
            ...prevState,
            roomChargeSheetVisible: false,
            roomOccupantSearchQuery: "",
            roomOccupantsSearchResults: [],
            selectedOccupant: null,
          }))
        }
        onOk={handleProcessPayment}
        okDisabled={isEmpty(paymentState?.selectedOccupant?.guest_name)}
        okText={t("secure.facility.table_service.table_service_cart.table_service_cart.121")}
        stacked
      >
        <Input
          label={t("secure.facility.table_service.table_service_cart.table_service_cart.122")}
          type="search"
          onChange={e => setPaymentState(prevState => ({ ...prevState, roomOccupantSearchQuery: e.target.value }))}
          value={paymentState?.roomOccupantSearchQuery}
        />
        {paymentState?.roomOccupantsSearchResults.map((occupant, index) => {
          return (
            <div key={index} className="flex flex-row justify-between p-3 border-b">
              <Checkbox
                size="small"
                value={occupant.guest_name}
                checked={isEqual(occupant, paymentState?.selectedOccupant)}
                onChange={() =>
                  setPaymentState(prev => ({
                    ...prev,
                    selectedOccupant: cloneDeep(occupant),
                  }))
                }
                label={occupant.guest_name}
              />
            </div>
          );
        })}
      </Sheet>

      <Sheet
        size={"small"}
        closable
        title={t("secure.facility.table_service.table_service_cart.table_service_cart.123")}
        cancelText={t("secure.facility.table_service.table_service_cart.table_service_cart.124")}
        open={manualStripeState.visible}
        okText={t("secure.facility.table_service.table_service_cart.table_service_cart.125")}
        okDisabled={!elementsComplete}
        cancelDisabled={manualProcessing}
        backDropCancel={false}
        stacked
        onOk={() => {
          if (!submitTrigger) {
            setSubmitTrigger(!submitTrigger);
          }
        }}
        onCancel={async () => {
          await cancelManualCreditPaymentIntent(
            manualStripeState?.transaction?.payment_intent_id as string,
            manualStripeState?.transaction?.id as number,
          );
          if (elements) {
            elements.getElement(CardNumberElement).clear();
            elements.getElement(CardExpiryElement).clear();
            elements.getElement(CardCvcElement).clear();
          }
          setManualStripeState(prevState => ({
            ...prevState,
            visible: false,
            transaction: {},
          }));
        }}
      >
        <CheckoutForm
          onChange={handleCardSectionChange}
          onSubmit={() => handleManualProcessing()}
          trigger={submitTrigger}
          transaction={manualStripeState.transaction}
          onError={(message: string) => {
            setSubmitTrigger(false);
            setManualProcessing(false);
            dispatch(showError(message));
          }}
          onSuccess={async () => {
            // Clean values
            dispatch(showSuccess(t("secure.facility.table_service.table_service_cart.table_service_cart.126")));
            setManualStripeState(prevState => ({
              ...prevState,
              visible: false,
              transaction: {},
              elementComplete: {
                cardCvc: false,
                cardExpiry: false,
                cardNumber: false,
              },
            }));
            setSubmitTrigger(false);
            dispatch(enqueue());
            await updateOrder(order?.id, true);
            dispatch(dequeue());
          }}
        />
      </Sheet>

      {paymentState.paymentModalVisible && (
        <Sheet
          open={paymentState.paymentModalVisible}
          size="small"
          closable
          title={t("Payment")}
          onCancel={closePaymentSheet}
          onOk={handleProcessPaymentCheck}
          cancelText={t("secure.facility.table_service.table_service_cart.table_service_cart.124")}
          okText={
            paymentState.paymentOption?.payment_method === "gift_card"
              ? t("secure.facility.table_service.table_service_cart.table_service_cart.127")
              : t("secure.facility.table_service.table_service_cart.table_service_cart.128")
          }
          backDropCancel={false}
          okDisabled={paymentState.paymentOption === null || paymentState.paymentAmount === "" ? true : false}
          okLoading={paymentState?.paymentInProgress}
          height="flexible"
        >
          <FormLayout>
            <FormLayout.Group>
              <PaymentMethods
                onChange={handlePaymentOptionChange}
                paymentOptions={(permissions?.payment_option_deposit && cart?.customer_id) ? facilityStore?.paymentOptions : facilityStore?.paymentOptions?.filter(option => option?.type !== "deposit")}
                cardReaderAvailable={terminalStore?.reader === null ? false : true}
                cart={cart}
                paymentAmount={Number(paymentState.paymentAmount)}
                value={paymentState.paymentOption}
              />
            </FormLayout.Group>
            <FormLayout.Group>
              {order && <CartTransactions transactions={order?.transactions} currency={order?.currency} />}
            </FormLayout.Group>
            {paymentState?.paymentInProgress ? (
              <FormLayout.Group>
                <div className="table-service-loader">
                  <Spin />
                </div>
              </FormLayout.Group>
            ) : null}
            <FormLayout.Group>
              {facilityStore?.paymentOptions.length === 0 ? null : (
                <Input
                  prefix={getCurrencySymbol(cartStore?.cart?.currency ?? "CAD")}
                  type="number"
                  label={t("Amount")}
                  id="paymentAmount"
                  value={paymentState.paymentAmount}
                  onChange={e => setPaymentState(prevState => ({ ...prevState, paymentAmount: e.target.value }))}
                />
              )}
            </FormLayout.Group>
          </FormLayout>
        </Sheet>
      )}

      <Popup
        type="info"
        open={paymentState.changeDueVisible}
        title={`${t(
          "secure.facility.table_service.table_service_cart.table_service_cart.129",
        )} ${paymentState.changeDue?.toFixed(2)}`}
        description=""
        closable
        onOk={() => setPaymentState(prevState => ({ ...prevState, changeDueVisible: false, changeDue: null }))}
        okText={t("secure.facility.table_service.table_service_cart.table_service_cart.100")}
        backDropCancel={false}
        stacked
      />

      {/* Redeem Ticket Sheet */}
      <Sheet
        title={t("Redeem Ticket")}
        open={redeemTicketModal.isOpen}
        size="medium"
        closable
        onCancel={() =>
          setRedeemTicketModal(prev => ({
            ...prev,
            isOpen: false,
            ticketCode: "",
            scannedTickets: [],
            scannedTicketQuantities: {},
            selectedCustomerTickets: [],
            selectedCustomerTicketQuantities: {},
          }))
        }
        onOk={(): void => void handleRedeemTicket()}
        okText={t("Redeem")}
        cancelText={t("Cancel")}
      >
        <div className="redeem-ticket-sheet-body">
        <Tabs
          tabs={[
            { id: "code", content: t("Scan") },
            { id: "customer", content: t("Available"), disabled: !cart?.customer?.id },
          ]}
          selected={redeemTicketModal.selectedTab}
          onSelect={(selected: number) => setRedeemTicketModal(prev => ({ ...prev, selectedTab: selected }))}
        >
          {redeemTicketModal.selectedTab === 0 && (
            <>
              <FormLayout>
                <FormLayout.Group>
                  <Input
                    id="redeemTicketCode"
                    placeholder={t("Scan Ticket / Barcode")}
                    value={redeemTicketModal.ticketCode}
                    onChange={e => setRedeemTicketModal(prev => ({ ...prev, ticketCode: e.target.value }))}
                    onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {
                      if (e.key === "Enter") {
                        void handleScanTicket();
                      }
                    }}
                    trailingButtons={[
                      <Button key={1} onClick={() => void handleScanTicket()} type="secondary">
                        {t('Enter')}
                      </Button>,
                    ]}
                  />
                </FormLayout.Group>
              </FormLayout>

              <DataTable
                className="mt-3 redeem-ticket-table"
                textWrap
                columns={[
                  { label: t("Title") },
                  { label: t("Ticket #") },
                  { label: t("Barcode") },
                  { label: t("Quantity") },
                  { label: "" },
                  { label: "" },
                ]}
              >
                {redeemTicketModal.scannedTickets.map((ticketStub: any, index: number) => (
                  <tr key={index}>
                    <td>
                      <p className="text-xs">
                        {ticketStub.ticket?.title}
                      </p>
                    </td>
                    <td><p className="text-xs">{ticketStub.code}</p></td>
                    <td><p className="text-xs">{ticketStub.code}</p></td>
                    <td>
                      {isMultiUseTicket(ticketStub as IStub) ? (
                        <TicketRedemptionQuantityInput
                          id={`table-service-scanned-ticket-quantity-${ticketStub.id}`}
                          value={getTicketRedemptionQuantity(ticketStub.id as number, redeemTicketModal.scannedTicketQuantities)}
                          max={getMaxRedemptionQuantity(ticketStub as IStub)}
                          onChange={quantity =>
                            setRedeemTicketModal(prev => ({
                              ...prev,
                              scannedTicketQuantities: {
                                ...prev.scannedTicketQuantities,
                                [ticketStub.id]: quantity,
                              },
                            }))
                          }
                        />
                      ) : (
                        1
                      )}
                    </td>
                    <td>
                      <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip id="ticket-validated-tooltip">{t("Ticket Validated")}</Tooltip>}
                      >
                        <FontAwesomeIcon
                          className="inventory-counts-success"
                          size="1x"
                          icon={faCircleCheck}
                        />
                      </OverlayTrigger>
                    </td>
                    <td className="text-right">
                      <FontAwesomeIcon
                        onClick={() => removeScannedTicket(index)}
                        icon={faTrashCanXmark}
                        size="1x"
                        className="cursor-pointer"
                      />
                    </td>
                  </tr>
                ))}
              </DataTable>
            </>
          )}
          {redeemTicketModal.selectedTab === 1 && (
            <DataTable
              className="mt-3 redeem-ticket-table"
              textWrap
              columns={[
                { label: t("Title") },
                { label: t("Number") },
                { label: t("Expires") },
                { label: t("Remaining Redemptions") },
                { label: t("Quantity") },
                { label: "" },
              ]}
              footer={{
                tableLimit: TICKET_LIMIT,
                tableOffset: redeemTicketModal.ticketOffset,
                disableNextOffset:
                  !redeemTicketModal.availableTickets ||
                  !(redeemTicketModal.availableTickets.length === TICKET_LIMIT),
                handleTableOffset: direction => void handleAvailableTicketsOffset(direction),
              }}
            >
              {redeemTicketModal.availableTickets?.map((ticketStub: any, index: number) => {
                const isSelected = redeemTicketModal.selectedCustomerTickets.some((s: any) => s.id === ticketStub.id);

                return (
                <tr key={index}>
                  <td>
                    <p className="text-xs">
                      {ticketStub.ticket?.title}
                    </p>
                    {ticketStub.ticket?.subtitle && (
                      <p className="text-xs text-secondary-text">
                        {ticketStub.ticket.subtitle}
                      </p>
                    )}
                    {ticketStub?.is_shared ? <Badge type="primary" size="xsmall">{t("Shared")}</Badge> : null}
                  </td>
                  <td><p className="text-xs">{ticketStub.code}</p></td>
                  <td><p className="text-xs">{ticketStub.expiry_date ? ticketStub.expiry : t("No Expiry")}</p></td>
                  <td>{ticketStub?.redemptions_remaining}</td>
                  <td>
                    {isSelected && isMultiUseTicket(ticketStub as IStub) ? (
                      <TicketRedemptionQuantityInput
                        id={`table-service-available-ticket-quantity-${ticketStub.id}`}
                        value={getTicketRedemptionQuantity(
                          ticketStub.id as number,
                          redeemTicketModal.selectedCustomerTicketQuantities,
                        )}
                        max={getMaxRedemptionQuantity(ticketStub as IStub)}
                        onChange={quantity =>
                          setRedeemTicketModal(prev => ({
                            ...prev,
                            selectedCustomerTicketQuantities: {
                              ...prev.selectedCustomerTicketQuantities,
                              [ticketStub.id]: quantity,
                            },
                          }))
                        }
                      />
                    ) : isSelected ? (
                      1
                    ) : null}
                  </td>
                  <td>
                    <Checkbox
                      size="medium"
                      checked={isSelected}
                      onChange={e => {
                        if (e.target.checked) {
                          setRedeemTicketModal(prev => ({
                            ...prev,
                            selectedCustomerTickets: [...prev.selectedCustomerTickets, ticketStub],
                            selectedCustomerTicketQuantities: isMultiUseTicket(ticketStub as IStub)
                              ? { ...prev.selectedCustomerTicketQuantities, [ticketStub.id]: 1 }
                              : prev.selectedCustomerTicketQuantities,
                          }));
                        } else {
                          setRedeemTicketModal(prev => {
                            const selectedCustomerTicketQuantities = { ...prev.selectedCustomerTicketQuantities };
                            delete selectedCustomerTicketQuantities[ticketStub.id];

                            return {
                              ...prev,
                              selectedCustomerTickets: prev.selectedCustomerTickets.filter((s: any) => s.id !== ticketStub.id),
                              selectedCustomerTicketQuantities,
                            };
                          });
                        }
                      }}
                    />
                  </td>
                </tr>
                );
              })}
            </DataTable>
          )}
        </Tabs>
        </div>
      </Sheet>

      <Sheet
        open={viewNoteModal.isOpen}
        size="small"
        title={t("Add Note to Order")}
        onCancel={closeViewNoteModal}
        onOk={() => {
          void handleAddNote();
        }}
        stacked
      >
        <div className="pt-3 pb-3">
          <TextField
            label={t("Note")}
            value={viewNoteModal.addNote ?? ""}
            onChange={(e: ChangeEvent<HTMLTextAreaElement>) => updateViewNoteModal({ addNote: e.target.value })}
            rows={4}
          />
        </div>
      </Sheet>

      <OrderCompletePopup open={orderComplete.isOpen} setOpen={closeOrderCompletePopup} order={order} />
      {futureBookingPricingModal}
    </div>
  );
}

const cancel_reasons = (t: TFunction) => [
  {
    id: 1,
    title: t("secure.facility.table_service.table_service_cart.table_service_cart.130"),
  },
  {
    id: 2,
    title: t("secure.facility.table_service.table_service_cart.table_service_cart.131"),
  },
];
